// source: order-concierge.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.concierge_order.AddConcernMessageRequest', null, global);
goog.exportSymbol('proto.concierge_order.CampaignArchiveStateRequest', null, global);
goog.exportSymbol('proto.concierge_order.CampaignExportRequest', null, global);
goog.exportSymbol('proto.concierge_order.CampaignExportRequest.ExportType', null, global);
goog.exportSymbol('proto.concierge_order.CampaignFilter', null, global);
goog.exportSymbol('proto.concierge_order.CampaignFilterField', null, global);
goog.exportSymbol('proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest', null, global);
goog.exportSymbol('proto.concierge_order.CampaignUpdateBudgetRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConcernArea', null, global);
goog.exportSymbol('proto.concierge_order.ConcernAttachedFile', null, global);
goog.exportSymbol('proto.concierge_order.ConcernAuthorType', null, global);
goog.exportSymbol('proto.concierge_order.ConcernMessageResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConcernResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConcernStatus', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignAiResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignAnalysisStatusResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignAnalyticsRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignAnalyticsResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignBudgetOverview', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCitation', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCitationsOverTimeItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCompetitorRankingItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignContentPlanItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignContentPlanUpdate', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignCreateRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignDetailResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignForFilterRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignForFilterResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignGeneratePromptsRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignModelPerformance', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignPageRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignPlacementFunnelItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignPromptAnalysis', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignPromptAnalyticsItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignQualityTier', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignShareOfVoiceItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignStatusRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignTopCitedDomainItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignUpdateRequest', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignVisibilityAnalytics', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem', null, global);
goog.exportSymbol('proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem', null, global);
goog.exportSymbol('proto.concierge_order.DomainApprovalOutcome', null, global);
goog.exportSymbol('proto.concierge_order.DomainApprovalReviewRequest', null, global);
goog.exportSymbol('proto.concierge_order.DomainApprovalReviewResponse', null, global);
goog.exportSymbol('proto.concierge_order.DomainApprovalReviewSubmitRequest', null, global);
goog.exportSymbol('proto.concierge_order.DomainApprovalReviewSubmitResponse', null, global);
goog.exportSymbol('proto.concierge_order.DomainDecision', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainBatchRequest', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainFilter', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainFilterField', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainRequest', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainResponse', null, global);
goog.exportSymbol('proto.concierge_order.ExcludedDomainsFilterRequest', null, global);
goog.exportSymbol('proto.concierge_order.GetConcernRequest', null, global);
goog.exportSymbol('proto.concierge_order.ListWebhookDeliveriesRequest', null, global);
goog.exportSymbol('proto.concierge_order.ListWebhookDeliveriesResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderArchiveStateRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkExportRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkExportRequest.ExportType', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkFilter', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkFilterField', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkPageRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderBacklinkSortProto', null, global);
goog.exportSymbol('proto.concierge_order.OrderCreateRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderDetailsResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderFilter', null, global);
goog.exportSymbol('proto.concierge_order.OrderFilterField', null, global);
goog.exportSymbol('proto.concierge_order.OrderItemChangeStatusRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderItemContainerRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderItemRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderItemResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderPageRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderPricingResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderRenameRequest', null, global);
goog.exportSymbol('proto.concierge_order.OrderResponse', null, global);
goog.exportSymbol('proto.concierge_order.OrderStatistics', null, global);
goog.exportSymbol('proto.concierge_order.OrderUpdateRequest', null, global);
goog.exportSymbol('proto.concierge_order.RaiseConcernRequest', null, global);
goog.exportSymbol('proto.concierge_order.RedeliverWebhookRequest', null, global);
goog.exportSymbol('proto.concierge_order.RejectedDomainHistory', null, global);
goog.exportSymbol('proto.concierge_order.SendTestWebhookRequest', null, global);
goog.exportSymbol('proto.concierge_order.SendTestWebhookResponse', null, global);
goog.exportSymbol('proto.concierge_order.SuggestedDomain', null, global);
goog.exportSymbol('proto.concierge_order.WebhookDeliveryView', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ListWebhookDeliveriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ListWebhookDeliveriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ListWebhookDeliveriesRequest.displayName = 'proto.concierge_order.ListWebhookDeliveriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.WebhookDeliveryView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.WebhookDeliveryView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.WebhookDeliveryView.displayName = 'proto.concierge_order.WebhookDeliveryView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ListWebhookDeliveriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ListWebhookDeliveriesResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ListWebhookDeliveriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ListWebhookDeliveriesResponse.displayName = 'proto.concierge_order.ListWebhookDeliveriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.RedeliverWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.RedeliverWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.RedeliverWebhookRequest.displayName = 'proto.concierge_order.RedeliverWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.SendTestWebhookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.SendTestWebhookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.SendTestWebhookRequest.displayName = 'proto.concierge_order.SendTestWebhookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.SendTestWebhookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.SendTestWebhookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.SendTestWebhookResponse.displayName = 'proto.concierge_order.SendTestWebhookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ExcludedDomainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ExcludedDomainRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ExcludedDomainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ExcludedDomainRequest.displayName = 'proto.concierge_order.ExcludedDomainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ExcludedDomainBatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ExcludedDomainBatchRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ExcludedDomainBatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ExcludedDomainBatchRequest.displayName = 'proto.concierge_order.ExcludedDomainBatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ExcludedDomainsFilterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ExcludedDomainsFilterRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ExcludedDomainsFilterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ExcludedDomainsFilterRequest.displayName = 'proto.concierge_order.ExcludedDomainsFilterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ExcludedDomainFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ExcludedDomainFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ExcludedDomainFilter.displayName = 'proto.concierge_order.ExcludedDomainFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ExcludedDomainResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ExcludedDomainResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ExcludedDomainResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ExcludedDomainResponse.displayName = 'proto.concierge_order.ExcludedDomainResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignStatusRequest.displayName = 'proto.concierge_order.ConciergeCampaignStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignAnalysisStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.displayName = 'proto.concierge_order.ConciergeCampaignAnalysisStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignAnalyticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignAnalyticsResponse.displayName = 'proto.concierge_order.ConciergeCampaignAnalyticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignAnalyticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignAnalyticsRequest.displayName = 'proto.concierge_order.ConciergeCampaignAnalyticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.displayName = 'proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignPlacementFunnelItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignPlacementFunnelItem.displayName = 'proto.concierge_order.ConciergeCampaignPlacementFunnelItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.displayName = 'proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.displayName = 'proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.displayName = 'proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.displayName = 'proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignShareOfVoiceItem.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignShareOfVoiceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignShareOfVoiceItem.displayName = 'proto.concierge_order.ConciergeCampaignShareOfVoiceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.displayName = 'proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.displayName = 'proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCompetitorRankingItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCompetitorRankingItem.displayName = 'proto.concierge_order.ConciergeCampaignCompetitorRankingItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.displayName = 'proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.displayName = 'proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCitationsOverTimeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.displayName = 'proto.concierge_order.ConciergeCampaignCitationsOverTimeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignTopCitedDomainItem.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignTopCitedDomainItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignTopCitedDomainItem.displayName = 'proto.concierge_order.ConciergeCampaignTopCitedDomainItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.displayName = 'proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignPromptAnalyticsItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.displayName = 'proto.concierge_order.ConciergeCampaignPromptAnalyticsItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignPageRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignPageRequest.displayName = 'proto.concierge_order.ConciergeCampaignPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignForFilterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignForFilterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignForFilterRequest.displayName = 'proto.concierge_order.ConciergeCampaignForFilterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignForFilterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignForFilterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignForFilterResponse.displayName = 'proto.concierge_order.ConciergeCampaignForFilterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.CampaignFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.CampaignFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.CampaignFilter.displayName = 'proto.concierge_order.CampaignFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignResponse.displayName = 'proto.concierge_order.ConciergeCampaignResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignDetailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignDetailResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignDetailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignDetailResponse.displayName = 'proto.concierge_order.ConciergeCampaignDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignVisibilityAnalytics.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignVisibilityAnalytics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignVisibilityAnalytics.displayName = 'proto.concierge_order.ConciergeCampaignVisibilityAnalytics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.displayName = 'proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignModelPerformance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignModelPerformance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignModelPerformance.displayName = 'proto.concierge_order.ConciergeCampaignModelPerformance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignPromptAnalysis.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignPromptAnalysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignPromptAnalysis.displayName = 'proto.concierge_order.ConciergeCampaignPromptAnalysis';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCitation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCitation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCitation.displayName = 'proto.concierge_order.ConciergeCampaignCitation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignAiResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignAiResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignAiResponse.displayName = 'proto.concierge_order.ConciergeCampaignAiResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignBudgetOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignBudgetOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignBudgetOverview.displayName = 'proto.concierge_order.ConciergeCampaignBudgetOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignContentPlanItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignContentPlanItem.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignContentPlanItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignContentPlanItem.displayName = 'proto.concierge_order.ConciergeCampaignContentPlanItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignContentPlanUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignContentPlanUpdate.displayName = 'proto.concierge_order.ConciergeCampaignContentPlanUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignQualityTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignQualityTier.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignQualityTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignQualityTier.displayName = 'proto.concierge_order.ConciergeCampaignQualityTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignCreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignCreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignCreateRequest.displayName = 'proto.concierge_order.ConciergeCampaignCreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignGeneratePromptsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.displayName = 'proto.concierge_order.ConciergeCampaignGeneratePromptsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConciergeCampaignUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConciergeCampaignUpdateRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConciergeCampaignUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConciergeCampaignUpdateRequest.displayName = 'proto.concierge_order.ConciergeCampaignUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderPageRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderPageRequest.displayName = 'proto.concierge_order.OrderPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderFilter.displayName = 'proto.concierge_order.OrderFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderResponse.displayName = 'proto.concierge_order.OrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderCreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderCreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderCreateRequest.displayName = 'proto.concierge_order.OrderCreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderArchiveStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderArchiveStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderArchiveStateRequest.displayName = 'proto.concierge_order.OrderArchiveStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.CampaignArchiveStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.CampaignArchiveStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.CampaignArchiveStateRequest.displayName = 'proto.concierge_order.CampaignArchiveStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.CampaignUpdateBudgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.CampaignUpdateBudgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.CampaignUpdateBudgetRequest.displayName = 'proto.concierge_order.CampaignUpdateBudgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.displayName = 'proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderUpdateRequest.displayName = 'proto.concierge_order.OrderUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderRenameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderRenameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderRenameRequest.displayName = 'proto.concierge_order.OrderRenameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderDetailsResponse.displayName = 'proto.concierge_order.OrderDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderStatistics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderStatistics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderStatistics.displayName = 'proto.concierge_order.OrderStatistics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderItemContainerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderItemContainerRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderItemContainerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderItemContainerRequest.displayName = 'proto.concierge_order.OrderItemContainerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderItemRequest.displayName = 'proto.concierge_order.OrderItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderItemChangeStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderItemChangeStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderItemChangeStatusRequest.displayName = 'proto.concierge_order.OrderItemChangeStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.DomainApprovalReviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.DomainApprovalReviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.DomainApprovalReviewRequest.displayName = 'proto.concierge_order.DomainApprovalReviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.DomainApprovalReviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.DomainApprovalReviewResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.DomainApprovalReviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.DomainApprovalReviewResponse.displayName = 'proto.concierge_order.DomainApprovalReviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.SuggestedDomain = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.SuggestedDomain, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.SuggestedDomain.displayName = 'proto.concierge_order.SuggestedDomain';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.RejectedDomainHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.RejectedDomainHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.RejectedDomainHistory.displayName = 'proto.concierge_order.RejectedDomainHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.DomainApprovalReviewSubmitRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.DomainApprovalReviewSubmitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.DomainApprovalReviewSubmitRequest.displayName = 'proto.concierge_order.DomainApprovalReviewSubmitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.DomainDecision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.DomainDecision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.DomainDecision.displayName = 'proto.concierge_order.DomainDecision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.DomainApprovalReviewSubmitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.DomainApprovalReviewSubmitResponse.displayName = 'proto.concierge_order.DomainApprovalReviewSubmitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderItemResponse.displayName = 'proto.concierge_order.OrderItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderPricingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderPricingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderPricingResponse.displayName = 'proto.concierge_order.OrderPricingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderBacklinkPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderBacklinkPageRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderBacklinkPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderBacklinkPageRequest.displayName = 'proto.concierge_order.OrderBacklinkPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderBacklinkFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.OrderBacklinkFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderBacklinkFilter.displayName = 'proto.concierge_order.OrderBacklinkFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderBacklinkExportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderBacklinkExportRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderBacklinkExportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderBacklinkExportRequest.displayName = 'proto.concierge_order.OrderBacklinkExportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.CampaignExportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.CampaignExportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.CampaignExportRequest.displayName = 'proto.concierge_order.CampaignExportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.OrderBacklinkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.OrderBacklinkResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.OrderBacklinkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.OrderBacklinkResponse.displayName = 'proto.concierge_order.OrderBacklinkResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConcernAttachedFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.ConcernAttachedFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConcernAttachedFile.displayName = 'proto.concierge_order.ConcernAttachedFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConcernMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConcernMessageResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConcernMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConcernMessageResponse.displayName = 'proto.concierge_order.ConcernMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.ConcernResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.ConcernResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.ConcernResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.ConcernResponse.displayName = 'proto.concierge_order.ConcernResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.RaiseConcernRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.RaiseConcernRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.RaiseConcernRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.RaiseConcernRequest.displayName = 'proto.concierge_order.RaiseConcernRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.GetConcernRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_order.GetConcernRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.GetConcernRequest.displayName = 'proto.concierge_order.GetConcernRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_order.AddConcernMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_order.AddConcernMessageRequest.repeatedFields_, null);
};
goog.inherits(proto.concierge_order.AddConcernMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_order.AddConcernMessageRequest.displayName = 'proto.concierge_order.AddConcernMessageRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ListWebhookDeliveriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ListWebhookDeliveriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ListWebhookDeliveriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
webhookEndpointId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ListWebhookDeliveriesRequest}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ListWebhookDeliveriesRequest;
  return proto.concierge_order.ListWebhookDeliveriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ListWebhookDeliveriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ListWebhookDeliveriesRequest}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebhookEndpointId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ListWebhookDeliveriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ListWebhookDeliveriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ListWebhookDeliveriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebhookEndpointId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 webhook_endpoint_id = 1;
 * @return {number}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.getWebhookEndpointId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ListWebhookDeliveriesRequest} returns this
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.setWebhookEndpointId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ListWebhookDeliveriesRequest} returns this
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ListWebhookDeliveriesRequest} returns this
 */
proto.concierge_order.ListWebhookDeliveriesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.WebhookDeliveryView.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.WebhookDeliveryView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.WebhookDeliveryView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.WebhookDeliveryView.toObject = function(includeInstance, msg) {
  var f, obj = {
uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
webhookEndpointId: jspb.Message.getFieldWithDefault(msg, 2, 0),
eventType: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
attemptCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
lastResponseCode: (f = msg.getLastResponseCode()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
lastError: (f = msg.getLastError()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
deliveredAt: (f = msg.getDeliveredAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.WebhookDeliveryView}
 */
proto.concierge_order.WebhookDeliveryView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.WebhookDeliveryView;
  return proto.concierge_order.WebhookDeliveryView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.WebhookDeliveryView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.WebhookDeliveryView}
 */
proto.concierge_order.WebhookDeliveryView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebhookEndpointId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttemptCount(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setLastResponseCode(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastError(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setDeliveredAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.WebhookDeliveryView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.WebhookDeliveryView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.WebhookDeliveryView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.WebhookDeliveryView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWebhookEndpointId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAttemptCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLastResponseCode();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getLastError();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDeliveredAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 webhook_endpoint_id = 2;
 * @return {number}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getWebhookEndpointId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setWebhookEndpointId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string event_type = 3;
 * @return {string}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 attempt_count = 5;
 * @return {number}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getAttemptCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setAttemptCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.Int32Value last_response_code = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getLastResponseCode = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
*/
proto.concierge_order.WebhookDeliveryView.prototype.setLastResponseCode = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.clearLastResponseCode = function() {
  return this.setLastResponseCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.WebhookDeliveryView.prototype.hasLastResponseCode = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue last_error = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getLastError = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
*/
proto.concierge_order.WebhookDeliveryView.prototype.setLastError = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.clearLastError = function() {
  return this.setLastError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.WebhookDeliveryView.prototype.hasLastError = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 updated_at = 9;
 * @return {number}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional google.protobuf.Int64Value delivered_at = 10;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.concierge_order.WebhookDeliveryView.prototype.getDeliveredAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 10));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
*/
proto.concierge_order.WebhookDeliveryView.prototype.setDeliveredAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.WebhookDeliveryView} returns this
 */
proto.concierge_order.WebhookDeliveryView.prototype.clearDeliveredAt = function() {
  return this.setDeliveredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.WebhookDeliveryView.prototype.hasDeliveredAt = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ListWebhookDeliveriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ListWebhookDeliveriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ListWebhookDeliveriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ListWebhookDeliveriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
deliveriesList: jspb.Message.toObjectList(msg.getDeliveriesList(),
    proto.concierge_order.WebhookDeliveryView.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ListWebhookDeliveriesResponse}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ListWebhookDeliveriesResponse;
  return proto.concierge_order.ListWebhookDeliveriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ListWebhookDeliveriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ListWebhookDeliveriesResponse}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_order.WebhookDeliveryView;
      reader.readMessage(value,proto.concierge_order.WebhookDeliveryView.deserializeBinaryFromReader);
      msg.addDeliveries(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ListWebhookDeliveriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ListWebhookDeliveriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ListWebhookDeliveriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeliveriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_order.WebhookDeliveryView.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated WebhookDeliveryView deliveries = 1;
 * @return {!Array<!proto.concierge_order.WebhookDeliveryView>}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.getDeliveriesList = function() {
  return /** @type{!Array<!proto.concierge_order.WebhookDeliveryView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.WebhookDeliveryView, 1));
};


/**
 * @param {!Array<!proto.concierge_order.WebhookDeliveryView>} value
 * @return {!proto.concierge_order.ListWebhookDeliveriesResponse} returns this
*/
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.setDeliveriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_order.WebhookDeliveryView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.WebhookDeliveryView}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.addDeliveries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_order.WebhookDeliveryView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ListWebhookDeliveriesResponse} returns this
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.clearDeliveriesList = function() {
  return this.setDeliveriesList([]);
};


/**
 * optional int64 total_items = 2;
 * @return {number}
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ListWebhookDeliveriesResponse} returns this
 */
proto.concierge_order.ListWebhookDeliveriesResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.RedeliverWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.RedeliverWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.RedeliverWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RedeliverWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
deliveryUid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.RedeliverWebhookRequest}
 */
proto.concierge_order.RedeliverWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.RedeliverWebhookRequest;
  return proto.concierge_order.RedeliverWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.RedeliverWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.RedeliverWebhookRequest}
 */
proto.concierge_order.RedeliverWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryUid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.RedeliverWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.RedeliverWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.RedeliverWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RedeliverWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeliveryUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string delivery_uid = 1;
 * @return {string}
 */
proto.concierge_order.RedeliverWebhookRequest.prototype.getDeliveryUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.RedeliverWebhookRequest} returns this
 */
proto.concierge_order.RedeliverWebhookRequest.prototype.setDeliveryUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.SendTestWebhookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.SendTestWebhookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.SendTestWebhookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SendTestWebhookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
eventType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.SendTestWebhookRequest}
 */
proto.concierge_order.SendTestWebhookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.SendTestWebhookRequest;
  return proto.concierge_order.SendTestWebhookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.SendTestWebhookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.SendTestWebhookRequest}
 */
proto.concierge_order.SendTestWebhookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.SendTestWebhookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.SendTestWebhookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.SendTestWebhookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SendTestWebhookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.concierge_order.SendTestWebhookRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.SendTestWebhookRequest} returns this
 */
proto.concierge_order.SendTestWebhookRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string event_type = 2;
 * @return {string}
 */
proto.concierge_order.SendTestWebhookRequest.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.SendTestWebhookRequest} returns this
 */
proto.concierge_order.SendTestWebhookRequest.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.SendTestWebhookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.SendTestWebhookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.SendTestWebhookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SendTestWebhookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
eventType: jspb.Message.getFieldWithDefault(msg, 1, ""),
matchedEndpoints: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.SendTestWebhookResponse}
 */
proto.concierge_order.SendTestWebhookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.SendTestWebhookResponse;
  return proto.concierge_order.SendTestWebhookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.SendTestWebhookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.SendTestWebhookResponse}
 */
proto.concierge_order.SendTestWebhookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchedEndpoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.SendTestWebhookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.SendTestWebhookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.SendTestWebhookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SendTestWebhookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchedEndpoints();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string event_type = 1;
 * @return {string}
 */
proto.concierge_order.SendTestWebhookResponse.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.SendTestWebhookResponse} returns this
 */
proto.concierge_order.SendTestWebhookResponse.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 matched_endpoints = 2;
 * @return {number}
 */
proto.concierge_order.SendTestWebhookResponse.prototype.getMatchedEndpoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.SendTestWebhookResponse} returns this
 */
proto.concierge_order.SendTestWebhookResponse.prototype.setMatchedEndpoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ExcludedDomainRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ExcludedDomainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ExcludedDomainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ExcludedDomainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ExcludedDomainRequest}
 */
proto.concierge_order.ExcludedDomainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ExcludedDomainRequest;
  return proto.concierge_order.ExcludedDomainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ExcludedDomainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ExcludedDomainRequest}
 */
proto.concierge_order.ExcludedDomainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ExcludedDomainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ExcludedDomainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ExcludedDomainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainRequest} returns this
 */
proto.concierge_order.ExcludedDomainRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.concierge_order.ExcludedDomainRequest.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ExcludedDomainRequest} returns this
 */
proto.concierge_order.ExcludedDomainRequest.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated int64 workspace_ids = 3;
 * @return {!Array<number>}
 */
proto.concierge_order.ExcludedDomainRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.concierge_order.ExcludedDomainRequest} returns this
 */
proto.concierge_order.ExcludedDomainRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ExcludedDomainRequest} returns this
 */
proto.concierge_order.ExcludedDomainRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ExcludedDomainRequest} returns this
 */
proto.concierge_order.ExcludedDomainRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ExcludedDomainBatchRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ExcludedDomainBatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ExcludedDomainBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainBatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
domainsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest}
 */
proto.concierge_order.ExcludedDomainBatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ExcludedDomainBatchRequest;
  return proto.concierge_order.ExcludedDomainBatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ExcludedDomainBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest}
 */
proto.concierge_order.ExcludedDomainBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomains(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ExcludedDomainBatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ExcludedDomainBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainBatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * repeated string domains = 1;
 * @return {!Array<string>}
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.getDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.setDomainsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.addDomains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.clearDomainsList = function() {
  return this.setDomainsList([]);
};


/**
 * repeated int64 workspace_ids = 2;
 * @return {!Array<number>}
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ExcludedDomainBatchRequest} returns this
 */
proto.concierge_order.ExcludedDomainBatchRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ExcludedDomainsFilterRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ExcludedDomainsFilterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ExcludedDomainsFilterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainsFilterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
optionalQuery: jspb.Message.getFieldWithDefault(msg, 3, ""),
optionalFiltersList: jspb.Message.toObjectList(msg.getOptionalFiltersList(),
    proto.concierge_order.ExcludedDomainFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ExcludedDomainsFilterRequest;
  return proto.concierge_order.ExcludedDomainsFilterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ExcludedDomainsFilterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalQuery(value);
      break;
    case 4:
      var value = new proto.concierge_order.ExcludedDomainFilter;
      reader.readMessage(value,proto.concierge_order.ExcludedDomainFilter.deserializeBinaryFromReader);
      msg.addOptionalFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ExcludedDomainsFilterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ExcludedDomainsFilterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainsFilterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOptionalQuery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptionalFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.ExcludedDomainFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest} returns this
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest} returns this
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string optional_query = 3;
 * @return {string}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.getOptionalQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest} returns this
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.setOptionalQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ExcludedDomainFilter optional_filters = 4;
 * @return {!Array<!proto.concierge_order.ExcludedDomainFilter>}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.getOptionalFiltersList = function() {
  return /** @type{!Array<!proto.concierge_order.ExcludedDomainFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ExcludedDomainFilter, 4));
};


/**
 * @param {!Array<!proto.concierge_order.ExcludedDomainFilter>} value
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest} returns this
*/
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.setOptionalFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.ExcludedDomainFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ExcludedDomainFilter}
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.addOptionalFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.ExcludedDomainFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ExcludedDomainsFilterRequest} returns this
 */
proto.concierge_order.ExcludedDomainsFilterRequest.prototype.clearOptionalFiltersList = function() {
  return this.setOptionalFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ExcludedDomainFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ExcludedDomainFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ExcludedDomainFilter}
 */
proto.concierge_order.ExcludedDomainFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ExcludedDomainFilter;
  return proto.concierge_order.ExcludedDomainFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ExcludedDomainFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ExcludedDomainFilter}
 */
proto.concierge_order.ExcludedDomainFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_order.ExcludedDomainFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ExcludedDomainFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ExcludedDomainFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainFilter} returns this
 */
proto.concierge_order.ExcludedDomainFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ExcludedDomainFilterField field = 2;
 * @return {!proto.concierge_order.ExcludedDomainFilterField}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.getField = function() {
  return /** @type {!proto.concierge_order.ExcludedDomainFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_order.ExcludedDomainFilterField} value
 * @return {!proto.concierge_order.ExcludedDomainFilter} returns this
 */
proto.concierge_order.ExcludedDomainFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ExcludedDomainFilter} returns this
 */
proto.concierge_order.ExcludedDomainFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.concierge_order.ExcludedDomainFilter} returns this
 */
proto.concierge_order.ExcludedDomainFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.concierge_order.ExcludedDomainFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.concierge_order.ExcludedDomainFilter} returns this
 */
proto.concierge_order.ExcludedDomainFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ExcludedDomainResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ExcludedDomainResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ExcludedDomainResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdBy: jspb.Message.getFieldWithDefault(msg, 4, 0),
reason: jspb.Message.getFieldWithDefault(msg, 5, ""),
totalItems: jspb.Message.getFieldWithDefault(msg, 6, 0),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ExcludedDomainResponse}
 */
proto.concierge_order.ExcludedDomainResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ExcludedDomainResponse;
  return proto.concierge_order.ExcludedDomainResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ExcludedDomainResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ExcludedDomainResponse}
 */
proto.concierge_order.ExcludedDomainResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ExcludedDomainResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ExcludedDomainResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ExcludedDomainResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedBy();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_by = 4;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getCreatedBy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string reason = 5;
 * @return {string}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 total_items = 6;
 * @return {number}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated int64 workspace_ids = 7;
 * @return {!Array<number>}
 */
proto.concierge_order.ExcludedDomainResponse.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ExcludedDomainResponse} returns this
 */
proto.concierge_order.ExcludedDomainResponse.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignStatusRequest}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignStatusRequest;
  return proto.concierge_order.ConciergeCampaignStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignStatusRequest}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.ConciergeCampaignStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignStatusRequest} returns this
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignStatusRequest} returns this
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.ConciergeCampaignStatus status = 3;
 * @return {!proto.common.ConciergeCampaignStatus}
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignStatusRequest} returns this
 */
proto.concierge_order.ConciergeCampaignStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
analysisStatus: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse}
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignAnalysisStatusResponse;
  return proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse}
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (reader.readEnum());
      msg.setAnalysisStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnalysisStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional common.ConciergeCampaignAnalysisStatus analysis_status = 1;
 * @return {!proto.common.ConciergeCampaignAnalysisStatus}
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.prototype.getAnalysisStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalysisStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalysisStatusResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalysisStatusResponse.prototype.setAnalysisStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignAnalyticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalCampaigns: jspb.Message.getFieldWithDefault(msg, 1, 0),
activeCampaigns: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalBudget: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
placementsOrdered: jspb.Message.getFieldWithDefault(msg, 4, 0),
placementsInProgress: jspb.Message.getFieldWithDefault(msg, 5, 0),
placementsLive: jspb.Message.getFieldWithDefault(msg, 6, 0),
placementsRefunded: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignAnalyticsResponse;
  return proto.concierge_order.ConciergeCampaignAnalyticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCampaigns(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveCampaigns(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalBudget(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsOrdered(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsInProgress(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsLive(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsRefunded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignAnalyticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalCampaigns();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActiveCampaigns();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getPlacementsOrdered();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPlacementsInProgress();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPlacementsLive();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPlacementsRefunded();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 total_campaigns = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getTotalCampaigns = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setTotalCampaigns = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 active_campaigns = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getActiveCampaigns = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setActiveCampaigns = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double total_budget = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getTotalBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setTotalBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 placements_ordered = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getPlacementsOrdered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setPlacementsOrdered = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 placements_in_progress = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getPlacementsInProgress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setPlacementsInProgress = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 placements_live = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getPlacementsLive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setPlacementsLive = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 placements_refunded = 7;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.getPlacementsRefunded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsResponse.prototype.setPlacementsRefunded = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignAnalyticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
campaignId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsRequest}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignAnalyticsRequest;
  return proto.concierge_order.ConciergeCampaignAnalyticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsRequest}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignAnalyticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignAnalyticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsRequest} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 campaign_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAnalyticsRequest} returns this
 */
proto.concierge_order.ConciergeCampaignAnalyticsRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalSpend: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
monthlyBudget: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
monthlySpend: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
placementFunnelList: jspb.Message.toObjectList(msg.getPlacementFunnelList(),
    proto.concierge_order.ConciergeCampaignPlacementFunnelItem.toObject, includeInstance),
placementsOrdered: jspb.Message.getFieldWithDefault(msg, 5, 0),
placementsLive: jspb.Message.getFieldWithDefault(msg, 6, 0),
placementsCited: jspb.Message.getFieldWithDefault(msg, 7, 0),
placementsRefunded: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse;
  return proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalSpend(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyBudget(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlySpend(value);
      break;
    case 4:
      var value = new proto.concierge_order.ConciergeCampaignPlacementFunnelItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignPlacementFunnelItem.deserializeBinaryFromReader);
      msg.addPlacementFunnel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsOrdered(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsLive(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsCited(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementsRefunded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalSpend();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMonthlyBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMonthlySpend();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getPlacementFunnelList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.ConciergeCampaignPlacementFunnelItem.serializeBinaryToWriter
    );
  }
  f = message.getPlacementsOrdered();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPlacementsLive();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPlacementsCited();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPlacementsRefunded();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional double total_spend = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getTotalSpend = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setTotalSpend = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double monthly_budget = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getMonthlyBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setMonthlyBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double monthly_spend = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getMonthlySpend = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setMonthlySpend = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * repeated ConciergeCampaignPlacementFunnelItem placement_funnel = 4;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignPlacementFunnelItem>}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getPlacementFunnelList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignPlacementFunnelItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignPlacementFunnelItem, 4));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignPlacementFunnelItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setPlacementFunnelList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.addPlacementFunnel = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.ConciergeCampaignPlacementFunnelItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.clearPlacementFunnelList = function() {
  return this.setPlacementFunnelList([]);
};


/**
 * optional int32 placements_ordered = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getPlacementsOrdered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setPlacementsOrdered = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 placements_live = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getPlacementsLive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setPlacementsLive = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 placements_cited = 7;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getPlacementsCited = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setPlacementsCited = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 placements_refunded = 8;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.getPlacementsRefunded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignOverviewAnalyticsResponse.prototype.setPlacementsRefunded = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignPlacementFunnelItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
ordered: jspb.Message.getFieldWithDefault(msg, 2, 0),
live: jspb.Message.getFieldWithDefault(msg, 3, 0),
cited: jspb.Message.getFieldWithDefault(msg, 4, 0),
refunded: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignPlacementFunnelItem;
  return proto.concierge_order.ConciergeCampaignPlacementFunnelItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdered(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLive(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCited(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRefunded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignPlacementFunnelItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrdered();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLive();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCited();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRefunded();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} returns this
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 ordered = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.getOrdered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} returns this
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.setOrdered = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 live = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.getLive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} returns this
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.setLive = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 cited = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.getCited = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} returns this
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.setCited = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 refunded = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.getRefunded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPlacementFunnelItem} returns this
 */
proto.concierge_order.ConciergeCampaignPlacementFunnelItem.prototype.setRefunded = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.repeatedFields_ = [5,7,9,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
visibilityScoreValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
visibilityScoreDelta: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
shareOfVoiceValue: jspb.Message.getFieldWithDefault(msg, 3, 0),
shareOfVoiceDelta: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
visibilityScoreOverTimeList: jspb.Message.toObjectList(msg.getVisibilityScoreOverTimeList(),
    proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.toObject, includeInstance),
visibilityBrandScoreRank: (f = msg.getVisibilityBrandScoreRank()) && proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.toObject(includeInstance, f),
shareOfVoiceList: jspb.Message.toObjectList(msg.getShareOfVoiceList(),
    proto.concierge_order.ConciergeCampaignShareOfVoiceItem.toObject, includeInstance),
visibilityShareOfVoiceRank: (f = msg.getVisibilityShareOfVoiceRank()) && proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.toObject(includeInstance, f),
avgPositionByPlatformList: jspb.Message.toObjectList(msg.getAvgPositionByPlatformList(),
    proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.toObject, includeInstance),
competitorRankingsList: jspb.Message.toObjectList(msg.getCompetitorRankingsList(),
    proto.concierge_order.ConciergeCampaignCompetitorRankingItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse;
  return proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVisibilityScoreValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScoreDelta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShareOfVoiceValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShareOfVoiceDelta(value);
      break;
    case 5:
      var value = new proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.deserializeBinaryFromReader);
      msg.addVisibilityScoreOverTime(value);
      break;
    case 6:
      var value = new proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.deserializeBinaryFromReader);
      msg.setVisibilityBrandScoreRank(value);
      break;
    case 7:
      var value = new proto.concierge_order.ConciergeCampaignShareOfVoiceItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignShareOfVoiceItem.deserializeBinaryFromReader);
      msg.addShareOfVoice(value);
      break;
    case 8:
      var value = new proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.deserializeBinaryFromReader);
      msg.setVisibilityShareOfVoiceRank(value);
      break;
    case 9:
      var value = new proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.deserializeBinaryFromReader);
      msg.addAvgPositionByPlatform(value);
      break;
    case 10:
      var value = new proto.concierge_order.ConciergeCampaignCompetitorRankingItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCompetitorRankingItem.deserializeBinaryFromReader);
      msg.addCompetitorRankings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisibilityScoreValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVisibilityScoreDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getShareOfVoiceValue();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getShareOfVoiceDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getVisibilityScoreOverTimeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.serializeBinaryToWriter
    );
  }
  f = message.getVisibilityBrandScoreRank();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.serializeBinaryToWriter
    );
  }
  f = message.getShareOfVoiceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.concierge_order.ConciergeCampaignShareOfVoiceItem.serializeBinaryToWriter
    );
  }
  f = message.getVisibilityShareOfVoiceRank();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.serializeBinaryToWriter
    );
  }
  f = message.getAvgPositionByPlatformList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.serializeBinaryToWriter
    );
  }
  f = message.getCompetitorRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.concierge_order.ConciergeCampaignCompetitorRankingItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 visibility_score_value = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getVisibilityScoreValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setVisibilityScoreValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double visibility_score_delta = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getVisibilityScoreDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setVisibilityScoreDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 share_of_voice_value = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getShareOfVoiceValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setShareOfVoiceValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double share_of_voice_delta = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getShareOfVoiceDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setShareOfVoiceDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated ConciergeCampaignVisibilityOverTimeItem visibility_score_over_time = 5;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getVisibilityScoreOverTimeList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem, 5));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setVisibilityScoreOverTimeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.addVisibilityScoreOverTime = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearVisibilityScoreOverTimeList = function() {
  return this.setVisibilityScoreOverTimeList([]);
};


/**
 * optional ConciergeCampaignVisibilityBrandScoreRank visibility_brand_score_rank = 6;
 * @return {?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getVisibilityBrandScoreRank = function() {
  return /** @type{?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} */ (
    jspb.Message.getWrapperField(this, proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank, 6));
};


/**
 * @param {?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank|undefined} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setVisibilityBrandScoreRank = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearVisibilityBrandScoreRank = function() {
  return this.setVisibilityBrandScoreRank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.hasVisibilityBrandScoreRank = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated ConciergeCampaignShareOfVoiceItem share_of_voice = 7;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getShareOfVoiceList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignShareOfVoiceItem, 7));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setShareOfVoiceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.addShareOfVoice = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.concierge_order.ConciergeCampaignShareOfVoiceItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearShareOfVoiceList = function() {
  return this.setShareOfVoiceList([]);
};


/**
 * optional ConciergeCampaignVisibilityBrandScoreRank visibility_share_of_voice_rank = 8;
 * @return {?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getVisibilityShareOfVoiceRank = function() {
  return /** @type{?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} */ (
    jspb.Message.getWrapperField(this, proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank, 8));
};


/**
 * @param {?proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank|undefined} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setVisibilityShareOfVoiceRank = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearVisibilityShareOfVoiceRank = function() {
  return this.setVisibilityShareOfVoiceRank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.hasVisibilityShareOfVoiceRank = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated ConciergeCampaignAvgPositionByPlatformItem avg_position_by_platform = 9;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getAvgPositionByPlatformList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem, 9));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setAvgPositionByPlatformList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.addAvgPositionByPlatform = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearAvgPositionByPlatformList = function() {
  return this.setAvgPositionByPlatformList([]);
};


/**
 * repeated ConciergeCampaignCompetitorRankingItem competitor_rankings = 10;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCompetitorRankingItem>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.getCompetitorRankingsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCompetitorRankingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCompetitorRankingItem, 10));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCompetitorRankingItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.setCompetitorRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.addCompetitorRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.concierge_order.ConciergeCampaignCompetitorRankingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalyticsResponse.prototype.clearCompetitorRankingsList = function() {
  return this.setCompetitorRankingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank;
  return proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
me: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
score: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
delta: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem;
  return proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMe(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMe();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool me = 3;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.getMe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.setMe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double score = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double delta = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.getDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem.prototype.setDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated ConciergeCampaignVisibilityBrandScoreRankItem items = 1;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem>}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem, 1));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.ConciergeCampaignVisibilityBrandScoreRankItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityBrandScoreRank.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
score: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem;
  return proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double score = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityOverTimeItem.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignShareOfVoiceItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignShareOfVoiceItem;
  return proto.concierge_order.ConciergeCampaignShareOfVoiceItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = new proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignShareOfVoiceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.toObject = function(includeInstance, msg) {
  var f, obj = {
brand: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
me: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem;
  return proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMe();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} returns this
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} returns this
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional bool me = 3;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.getMe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem} returns this
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem.prototype.setMe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} returns this
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ShareOfVoiceBrandItem items = 2;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem>}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem, 2));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} returns this
*/
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem}
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.concierge_order.ConciergeCampaignShareOfVoiceItem.ShareOfVoiceBrandItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignShareOfVoiceItem} returns this
 */
proto.concierge_order.ConciergeCampaignShareOfVoiceItem.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.toObject = function(includeInstance, msg) {
  var f, obj = {
platform: jspb.Message.getFieldWithDefault(msg, 1, 0),
rank: jspb.Message.getFieldWithDefault(msg, 2, 0),
avgPosition: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
delta: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem;
  return proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.ConciergeCampaignPlatforms} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPosition(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvgPosition();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional common.ConciergeCampaignPlatforms platform = 1;
 * @return {!proto.common.ConciergeCampaignPlatforms}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.getPlatform = function() {
  return /** @type {!proto.common.ConciergeCampaignPlatforms} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} returns this
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 rank = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} returns this
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double avg_position = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.getAvgPosition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} returns this
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.setAvgPosition = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double delta = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.getDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem} returns this
 */
proto.concierge_order.ConciergeCampaignAvgPositionByPlatformItem.prototype.setDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCompetitorRankingItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.toObject = function(includeInstance, msg) {
  var f, obj = {
brand: jspb.Message.getFieldWithDefault(msg, 1, ""),
visibilityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
shareOfVoice: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
avgPosition: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
me: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
change: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCompetitorRankingItem;
  return proto.concierge_order.ConciergeCampaignCompetitorRankingItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShareOfVoice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPosition(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMe(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCompetitorRankingItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisibilityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getShareOfVoice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getAvgPosition();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMe();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getChange();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double visibility_score = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getVisibilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setVisibilityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double share_of_voice = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getShareOfVoice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setShareOfVoice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double avg_position = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getAvgPosition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setAvgPosition = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool me = 5;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getMe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setMe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional double change = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.getChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorRankingItem} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorRankingItem.prototype.setChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.repeatedFields_ = [10,11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
citationShare: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
citationShareDelta: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
citationRank: jspb.Message.getFieldWithDefault(msg, 3, 0),
citationsOverTimeList: jspb.Message.toObjectList(msg.getCitationsOverTimeList(),
    proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.toObject, includeInstance),
citationsVsCompetitorsList: jspb.Message.toObjectList(msg.getCitationsVsCompetitorsList(),
    proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.toObject, includeInstance),
topCitedDomainsList: jspb.Message.toObjectList(msg.getTopCitedDomainsList(),
    proto.concierge_order.ConciergeCampaignTopCitedDomainItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse;
  return proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCitationShare(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCitationShareDelta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCitationRank(value);
      break;
    case 10:
      var value = new proto.concierge_order.ConciergeCampaignCitationsOverTimeItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.deserializeBinaryFromReader);
      msg.addCitationsOverTime(value);
      break;
    case 11:
      var value = new proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.deserializeBinaryFromReader);
      msg.addCitationsVsCompetitors(value);
      break;
    case 12:
      var value = new proto.concierge_order.ConciergeCampaignTopCitedDomainItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignTopCitedDomainItem.deserializeBinaryFromReader);
      msg.addTopCitedDomains(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitationShare();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCitationShareDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCitationRank();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCitationsOverTimeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.serializeBinaryToWriter
    );
  }
  f = message.getCitationsVsCompetitorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.serializeBinaryToWriter
    );
  }
  f = message.getTopCitedDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.concierge_order.ConciergeCampaignTopCitedDomainItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional double citation_share = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getCitationShare = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setCitationShare = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double citation_share_delta = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getCitationShareDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setCitationShareDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 citation_rank = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getCitationRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setCitationRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ConciergeCampaignCitationsOverTimeItem citations_over_time = 10;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem>}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getCitationsOverTimeList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCitationsOverTimeItem, 10));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setCitationsOverTimeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.addCitationsOverTime = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.concierge_order.ConciergeCampaignCitationsOverTimeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.clearCitationsOverTimeList = function() {
  return this.setCitationsOverTimeList([]);
};


/**
 * repeated ConciergeCampaignCitationsRankVsCompetitors citations_vs_competitors = 11;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors>}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getCitationsVsCompetitorsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors, 11));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors>} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setCitationsVsCompetitorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.addCitationsVsCompetitors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.clearCitationsVsCompetitorsList = function() {
  return this.setCitationsVsCompetitorsList([]);
};


/**
 * repeated ConciergeCampaignTopCitedDomainItem top_cited_domains = 12;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignTopCitedDomainItem>}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.getTopCitedDomainsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignTopCitedDomainItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignTopCitedDomainItem, 12));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignTopCitedDomainItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.setTopCitedDomainsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem}
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.addTopCitedDomains = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.concierge_order.ConciergeCampaignTopCitedDomainItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignCitationAnalyticsResponse.prototype.clearTopCitedDomainsList = function() {
  return this.setTopCitedDomainsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
citations: jspb.Message.getFieldWithDefault(msg, 4, 0),
share: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
delta: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
me: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors;
  return proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCitations(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShare(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelta(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCitations();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getShare();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMe();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 citations = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getCitations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setCitations = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double share = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getShare = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setShare = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double delta = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional bool me = 7;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.getMe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsRankVsCompetitors.prototype.setMe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
owned: jspb.Message.getFieldWithDefault(msg, 2, 0),
respona: jspb.Message.getFieldWithDefault(msg, 3, 0),
earned: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCitationsOverTimeItem;
  return proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOwned(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRespona(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEarned(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOwned();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRespona();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEarned();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 owned = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.getOwned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.setOwned = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 respona = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.getRespona = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.setRespona = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 earned = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.getEarned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitationsOverTimeItem} returns this
 */
proto.concierge_order.ConciergeCampaignCitationsOverTimeItem.prototype.setEarned = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignTopCitedDomainItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
categoriesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
citations: jspb.Message.getFieldWithDefault(msg, 4, 0),
share: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
delta: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignTopCitedDomainItem;
  return proto.concierge_order.ConciergeCampaignTopCitedDomainItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCitations(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShare(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignTopCitedDomainItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCitations();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getShare();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string categories = 3;
 * @return {!Array<string>}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional int32 citations = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getCitations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setCitations = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double share = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getShare = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setShare = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double delta = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.getDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignTopCitedDomainItem} returns this
 */
proto.concierge_order.ConciergeCampaignTopCitedDomainItem.prototype.setDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse;
  return proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_order.ConciergeCampaignPromptAnalyticsItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ConciergeCampaignPromptAnalyticsItem items = 1;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem>}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignPromptAnalyticsItem, 1));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse} returns this
*/
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_order.ConciergeCampaignPromptAnalyticsItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.toObject = function(includeInstance, msg) {
  var f, obj = {
prompt: jspb.Message.getFieldWithDefault(msg, 1, ""),
aiResponse: jspb.Message.getFieldWithDefault(msg, 2, ""),
platform: jspb.Message.getFieldWithDefault(msg, 3, 0),
date: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignPromptAnalyticsItem;
  return proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiResponse(value);
      break;
    case 3:
      var value = /** @type {!proto.common.ConciergeCampaignPlatforms} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAiResponse();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string prompt = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ai_response = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.getAiResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.setAiResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.ConciergeCampaignPlatforms platform = 3;
 * @return {!proto.common.ConciergeCampaignPlatforms}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.getPlatform = function() {
  return /** @type {!proto.common.ConciergeCampaignPlatforms} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 date = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalyticsItem} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalyticsItem.prototype.setDate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignPageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.concierge_order.CampaignFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest}
 */
proto.concierge_order.ConciergeCampaignPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignPageRequest;
  return proto.concierge_order.ConciergeCampaignPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest}
 */
proto.concierge_order.ConciergeCampaignPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = new proto.concierge_order.CampaignFilter;
      reader.readMessage(value,proto.concierge_order.CampaignFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.CampaignFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest} returns this
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest} returns this
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest} returns this
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated CampaignFilter filters = 4;
 * @return {!Array<!proto.concierge_order.CampaignFilter>}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.concierge_order.CampaignFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.CampaignFilter, 4));
};


/**
 * @param {!Array<!proto.concierge_order.CampaignFilter>} value
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest} returns this
*/
proto.concierge_order.ConciergeCampaignPageRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.CampaignFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.CampaignFilter}
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.CampaignFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignPageRequest} returns this
 */
proto.concierge_order.ConciergeCampaignPageRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignForFilterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignForFilterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignForFilterRequest}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignForFilterRequest;
  return proto.concierge_order.ConciergeCampaignForFilterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignForFilterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignForFilterRequest}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignForFilterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignForFilterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignForFilterRequest} returns this
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignForFilterRequest} returns this
 */
proto.concierge_order.ConciergeCampaignForFilterRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignForFilterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignForFilterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalItems: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignForFilterResponse}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignForFilterResponse;
  return proto.concierge_order.ConciergeCampaignForFilterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignForFilterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignForFilterResponse}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignForFilterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignForFilterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignForFilterResponse} returns this
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignForFilterResponse} returns this
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 total_items = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignForFilterResponse} returns this
 */
proto.concierge_order.ConciergeCampaignForFilterResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.CampaignFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.CampaignFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.CampaignFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.CampaignFilter}
 */
proto.concierge_order.CampaignFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.CampaignFilter;
  return proto.concierge_order.CampaignFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.CampaignFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.CampaignFilter}
 */
proto.concierge_order.CampaignFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_order.CampaignFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.CampaignFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.CampaignFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.CampaignFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_order.CampaignFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignFilter} returns this
 */
proto.concierge_order.CampaignFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CampaignFilterField field = 2;
 * @return {!proto.concierge_order.CampaignFilterField}
 */
proto.concierge_order.CampaignFilter.prototype.getField = function() {
  return /** @type {!proto.concierge_order.CampaignFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_order.CampaignFilterField} value
 * @return {!proto.concierge_order.CampaignFilter} returns this
 */
proto.concierge_order.CampaignFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.concierge_order.CampaignFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.CampaignFilter} returns this
 */
proto.concierge_order.CampaignFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.concierge_order.CampaignFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.concierge_order.CampaignFilter} returns this
 */
proto.concierge_order.CampaignFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.concierge_order.CampaignFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.concierge_order.CampaignFilter} returns this
 */
proto.concierge_order.CampaignFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignResponse.repeatedFields_ = [5,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
url: jspb.Message.getFieldWithDefault(msg, 4, ""),
promptsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
visibilityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
visibilityChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
aiCitationShareScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
aiCitationCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
monthlyBudget: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
orderPlacedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
orderPlacedCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
platformsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
region: jspb.Message.getFieldWithDefault(msg, 14, ""),
autonomy: jspb.Message.getFieldWithDefault(msg, 15, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 16, 0),
createdBy: jspb.Message.getFieldWithDefault(msg, 17, 0),
analysisStatus: jspb.Message.getFieldWithDefault(msg, 18, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 19, 0),
folderId: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignResponse}
 */
proto.concierge_order.ConciergeCampaignResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignResponse;
  return proto.concierge_order.ConciergeCampaignResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignResponse}
 */
proto.concierge_order.ConciergeCampaignResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.common.ConciergeCampaignStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPrompts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScore(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityChange(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAiCitationShareScore(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiCitationCount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyBudget(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOrderPlacedAmount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderPlacedCount(value);
      break;
    case 13:
      var values = /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlatforms(values[i]);
      }
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 15:
      var value = /** @type {!proto.common.ConciergeCampaignAutonomy} */ (reader.readEnum());
      msg.setAutonomy(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedBy(value);
      break;
    case 18:
      var value = /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (reader.readEnum());
      msg.setAnalysisStatus(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPromptsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getVisibilityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getVisibilityChange();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getAiCitationShareScore();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getAiCitationCount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getMonthlyBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getOrderPlacedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getOrderPlacedCount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      13,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAutonomy();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getCreatedBy();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getAnalysisStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getFolderId();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.ConciergeCampaignStatus status = 2;
 * @return {!proto.common.ConciergeCampaignStatus}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string prompts = 5;
 * @return {!Array<string>}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getPromptsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setPromptsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.addPrompts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.clearPromptsList = function() {
  return this.setPromptsList([]);
};


/**
 * optional double visibility_score = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getVisibilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setVisibilityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double visibility_change = 7;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getVisibilityChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setVisibilityChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double ai_citation_share_score = 8;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getAiCitationShareScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setAiCitationShareScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 ai_citation_count = 9;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getAiCitationCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setAiCitationCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double monthly_budget = 10;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getMonthlyBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setMonthlyBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double order_placed_amount = 11;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getOrderPlacedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setOrderPlacedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional int32 order_placed_count = 12;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getOrderPlacedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setOrderPlacedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * repeated common.ConciergeCampaignPlatforms platforms = 13;
 * @return {!Array<!proto.common.ConciergeCampaignPlatforms>}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getPlatformsList = function() {
  return /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<!proto.common.ConciergeCampaignPlatforms>} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};


/**
 * optional string region = 14;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional common.ConciergeCampaignAutonomy autonomy = 15;
 * @return {!proto.common.ConciergeCampaignAutonomy}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getAutonomy = function() {
  return /** @type {!proto.common.ConciergeCampaignAutonomy} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAutonomy} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setAutonomy = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional int64 created_at = 16;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 created_by = 17;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getCreatedBy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional common.ConciergeCampaignAnalysisStatus analysis_status = 18;
 * @return {!proto.common.ConciergeCampaignAnalysisStatus}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getAnalysisStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalysisStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setAnalysisStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional int32 total_items = 19;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 folder_id = 20;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.getFolderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignResponse} returns this
 */
proto.concierge_order.ConciergeCampaignResponse.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignDetailResponse.repeatedFields_ = [6,12,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignDetailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignDetailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignDetailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
brandName: jspb.Message.getFieldWithDefault(msg, 4, ""),
url: jspb.Message.getFieldWithDefault(msg, 5, ""),
promptsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
visibilityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
visibilityChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
monthlyBudget: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
orderPlacedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
orderPlacedCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
platformsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
region: jspb.Message.getFieldWithDefault(msg, 13, ""),
autonomy: jspb.Message.getFieldWithDefault(msg, 14, 0),
analysisStatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
visibilityAnalytics: (f = msg.getVisibilityAnalytics()) && proto.concierge_order.ConciergeCampaignVisibilityAnalytics.toObject(includeInstance, f),
budgetOverview: (f = msg.getBudgetOverview()) && proto.concierge_order.ConciergeCampaignBudgetOverview.toObject(includeInstance, f),
contentPlanList: jspb.Message.toObjectList(msg.getContentPlanList(),
    proto.concierge_order.ConciergeCampaignContentPlanItem.toObject, includeInstance),
analyticsFrequency: jspb.Message.getFieldWithDefault(msg, 19, 0),
additionalContentGuidelines: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignDetailResponse;
  return proto.concierge_order.ConciergeCampaignDetailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.common.ConciergeCampaignStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPrompts(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScore(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityChange(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyBudget(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOrderPlacedAmount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderPlacedCount(value);
      break;
    case 12:
      var values = /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlatforms(values[i]);
      }
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 14:
      var value = /** @type {!proto.common.ConciergeCampaignAutonomy} */ (reader.readEnum());
      msg.setAutonomy(value);
      break;
    case 15:
      var value = /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (reader.readEnum());
      msg.setAnalysisStatus(value);
      break;
    case 16:
      var value = new proto.concierge_order.ConciergeCampaignVisibilityAnalytics;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignVisibilityAnalytics.deserializeBinaryFromReader);
      msg.setVisibilityAnalytics(value);
      break;
    case 17:
      var value = new proto.concierge_order.ConciergeCampaignBudgetOverview;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignBudgetOverview.deserializeBinaryFromReader);
      msg.setBudgetOverview(value);
      break;
    case 18:
      var value = new proto.concierge_order.ConciergeCampaignContentPlanItem;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignContentPlanItem.deserializeBinaryFromReader);
      msg.addContentPlan(value);
      break;
    case 19:
      var value = /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (reader.readEnum());
      msg.setAnalyticsFrequency(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionalContentGuidelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignDetailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPromptsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getVisibilityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getVisibilityChange();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getMonthlyBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getOrderPlacedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getOrderPlacedCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      12,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAutonomy();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getAnalysisStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getVisibilityAnalytics();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.concierge_order.ConciergeCampaignVisibilityAnalytics.serializeBinaryToWriter
    );
  }
  f = message.getBudgetOverview();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.concierge_order.ConciergeCampaignBudgetOverview.serializeBinaryToWriter
    );
  }
  f = message.getContentPlanList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.concierge_order.ConciergeCampaignContentPlanItem.serializeBinaryToWriter
    );
  }
  f = message.getAnalyticsFrequency();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getAdditionalContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.ConciergeCampaignStatus status = 2;
 * @return {!proto.common.ConciergeCampaignStatus}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string brand_name = 4;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string prompts = 6;
 * @return {!Array<string>}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getPromptsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setPromptsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.addPrompts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.clearPromptsList = function() {
  return this.setPromptsList([]);
};


/**
 * optional double visibility_score = 7;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getVisibilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setVisibilityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double visibility_change = 8;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getVisibilityChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setVisibilityChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double monthly_budget = 9;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getMonthlyBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setMonthlyBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double order_placed_amount = 10;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getOrderPlacedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setOrderPlacedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int32 order_placed_count = 11;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getOrderPlacedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setOrderPlacedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated common.ConciergeCampaignPlatforms platforms = 12;
 * @return {!Array<!proto.common.ConciergeCampaignPlatforms>}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getPlatformsList = function() {
  return /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<!proto.common.ConciergeCampaignPlatforms>} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};


/**
 * optional string region = 13;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional common.ConciergeCampaignAutonomy autonomy = 14;
 * @return {!proto.common.ConciergeCampaignAutonomy}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getAutonomy = function() {
  return /** @type {!proto.common.ConciergeCampaignAutonomy} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAutonomy} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setAutonomy = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional common.ConciergeCampaignAnalysisStatus analysis_status = 15;
 * @return {!proto.common.ConciergeCampaignAnalysisStatus}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getAnalysisStatus = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalysisStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalysisStatus} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setAnalysisStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional ConciergeCampaignVisibilityAnalytics visibility_analytics = 16;
 * @return {?proto.concierge_order.ConciergeCampaignVisibilityAnalytics}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getVisibilityAnalytics = function() {
  return /** @type{?proto.concierge_order.ConciergeCampaignVisibilityAnalytics} */ (
    jspb.Message.getWrapperField(this, proto.concierge_order.ConciergeCampaignVisibilityAnalytics, 16));
};


/**
 * @param {?proto.concierge_order.ConciergeCampaignVisibilityAnalytics|undefined} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
*/
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setVisibilityAnalytics = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.clearVisibilityAnalytics = function() {
  return this.setVisibilityAnalytics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.hasVisibilityAnalytics = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional ConciergeCampaignBudgetOverview budget_overview = 17;
 * @return {?proto.concierge_order.ConciergeCampaignBudgetOverview}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getBudgetOverview = function() {
  return /** @type{?proto.concierge_order.ConciergeCampaignBudgetOverview} */ (
    jspb.Message.getWrapperField(this, proto.concierge_order.ConciergeCampaignBudgetOverview, 17));
};


/**
 * @param {?proto.concierge_order.ConciergeCampaignBudgetOverview|undefined} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
*/
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setBudgetOverview = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.clearBudgetOverview = function() {
  return this.setBudgetOverview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.hasBudgetOverview = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated ConciergeCampaignContentPlanItem content_plan = 18;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignContentPlanItem>}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getContentPlanList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignContentPlanItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignContentPlanItem, 18));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignContentPlanItem>} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
*/
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setContentPlanList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.addContentPlan = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.concierge_order.ConciergeCampaignContentPlanItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.clearContentPlanList = function() {
  return this.setContentPlanList([]);
};


/**
 * optional common.ConciergeCampaignAnalyticsFrequency analytics_frequency = 19;
 * @return {!proto.common.ConciergeCampaignAnalyticsFrequency}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getAnalyticsFrequency = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalyticsFrequency} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setAnalyticsFrequency = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string additional_content_guidelines = 20;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.getAdditionalContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignDetailResponse} returns this
 */
proto.concierge_order.ConciergeCampaignDetailResponse.prototype.setAdditionalContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignVisibilityAnalytics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.toObject = function(includeInstance, msg) {
  var f, obj = {
visibilityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
visibilityScoreRank: jspb.Message.getFieldWithDefault(msg, 2, 0),
avgPosition: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
totalCitations: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalResponses: jspb.Message.getFieldWithDefault(msg, 5, 0),
uniqueSources: jspb.Message.getFieldWithDefault(msg, 6, 0),
modelPerformanceList: jspb.Message.toObjectList(msg.getModelPerformanceList(),
    proto.concierge_order.ConciergeCampaignModelPerformance.toObject, includeInstance),
competitorVisibilityRankingsList: jspb.Message.toObjectList(msg.getCompetitorVisibilityRankingsList(),
    proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.toObject, includeInstance),
promptAnalysisList: jspb.Message.toObjectList(msg.getPromptAnalysisList(),
    proto.concierge_order.ConciergeCampaignPromptAnalysis.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignVisibilityAnalytics;
  return proto.concierge_order.ConciergeCampaignVisibilityAnalytics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVisibilityScoreRank(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPosition(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCitations(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalResponses(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUniqueSources(value);
      break;
    case 7:
      var value = new proto.concierge_order.ConciergeCampaignModelPerformance;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignModelPerformance.deserializeBinaryFromReader);
      msg.addModelPerformance(value);
      break;
    case 8:
      var value = new proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.deserializeBinaryFromReader);
      msg.addCompetitorVisibilityRankings(value);
      break;
    case 9:
      var value = new proto.concierge_order.ConciergeCampaignPromptAnalysis;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignPromptAnalysis.deserializeBinaryFromReader);
      msg.addPromptAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignVisibilityAnalytics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisibilityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getVisibilityScoreRank();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvgPosition();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTotalCitations();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTotalResponses();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getUniqueSources();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getModelPerformanceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.concierge_order.ConciergeCampaignModelPerformance.serializeBinaryToWriter
    );
  }
  f = message.getCompetitorVisibilityRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.serializeBinaryToWriter
    );
  }
  f = message.getPromptAnalysisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.concierge_order.ConciergeCampaignPromptAnalysis.serializeBinaryToWriter
    );
  }
};


/**
 * optional double visibility_score = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getVisibilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setVisibilityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 visibility_score_rank = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getVisibilityScoreRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setVisibilityScoreRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double avg_position = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getAvgPosition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setAvgPosition = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 total_citations = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getTotalCitations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setTotalCitations = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 total_responses = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getTotalResponses = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setTotalResponses = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 unique_sources = 6;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getUniqueSources = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setUniqueSources = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated ConciergeCampaignModelPerformance model_performance = 7;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignModelPerformance>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getModelPerformanceList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignModelPerformance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignModelPerformance, 7));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignModelPerformance>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setModelPerformanceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignModelPerformance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.addModelPerformance = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.concierge_order.ConciergeCampaignModelPerformance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.clearModelPerformanceList = function() {
  return this.setModelPerformanceList([]);
};


/**
 * repeated ConciergeCampaignCompetitorVisibilityRanking competitor_visibility_rankings = 8;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getCompetitorVisibilityRankingsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking, 8));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setCompetitorVisibilityRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.addCompetitorVisibilityRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.clearCompetitorVisibilityRankingsList = function() {
  return this.setCompetitorVisibilityRankingsList([]);
};


/**
 * repeated ConciergeCampaignPromptAnalysis prompt_analysis = 9;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignPromptAnalysis>}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.getPromptAnalysisList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignPromptAnalysis>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignPromptAnalysis, 9));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignPromptAnalysis>} value
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
*/
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.setPromptAnalysisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalysis=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis}
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.addPromptAnalysis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.concierge_order.ConciergeCampaignPromptAnalysis, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignVisibilityAnalytics} returns this
 */
proto.concierge_order.ConciergeCampaignVisibilityAnalytics.prototype.clearPromptAnalysisList = function() {
  return this.setPromptAnalysisList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
visibilityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
mentionRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
avgPosition: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
isCurrentBrand: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking;
  return proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVisibilityScore(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMentionRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgPosition(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrentBrand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVisibilityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMentionRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getAvgPosition();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getIsCurrentBrand();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double visibility_score = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getVisibilityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setVisibilityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double mention_rate = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getMentionRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setMentionRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double avg_position = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getAvgPosition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setAvgPosition = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool is_current_brand = 6;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.getIsCurrentBrand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking} returns this
 */
proto.concierge_order.ConciergeCampaignCompetitorVisibilityRanking.prototype.setIsCurrentBrand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignModelPerformance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignModelPerformance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignModelPerformance.toObject = function(includeInstance, msg) {
  var f, obj = {
platform: jspb.Message.getFieldWithDefault(msg, 1, 0),
mentionRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
mentionedIn: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalPrompts: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignModelPerformance;
  return proto.concierge_order.ConciergeCampaignModelPerformance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignModelPerformance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.ConciergeCampaignPlatforms} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMentionRate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMentionedIn(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPrompts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignModelPerformance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignModelPerformance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignModelPerformance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMentionRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMentionedIn();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalPrompts();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional common.ConciergeCampaignPlatforms platform = 1;
 * @return {!proto.common.ConciergeCampaignPlatforms}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.getPlatform = function() {
  return /** @type {!proto.common.ConciergeCampaignPlatforms} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance} returns this
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double mention_rate = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.getMentionRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance} returns this
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.setMentionRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 mentioned_in = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.getMentionedIn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance} returns this
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.setMentionedIn = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_prompts = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.getTotalPrompts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignModelPerformance} returns this
 */
proto.concierge_order.ConciergeCampaignModelPerformance.prototype.setTotalPrompts = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignPromptAnalysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
prompt: jspb.Message.getFieldWithDefault(msg, 2, ""),
aiResponsesList: jspb.Message.toObjectList(msg.getAiResponsesList(),
    proto.concierge_order.ConciergeCampaignAiResponse.toObject, includeInstance),
citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    proto.concierge_order.ConciergeCampaignCitation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignPromptAnalysis;
  return proto.concierge_order.ConciergeCampaignPromptAnalysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 3:
      var value = new proto.concierge_order.ConciergeCampaignAiResponse;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignAiResponse.deserializeBinaryFromReader);
      msg.addAiResponses(value);
      break;
    case 4:
      var value = new proto.concierge_order.ConciergeCampaignCitation;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignPromptAnalysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignPromptAnalysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAiResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_order.ConciergeCampaignAiResponse.serializeBinaryToWriter
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.ConciergeCampaignCitation.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string prompt = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ConciergeCampaignAiResponse ai_responses = 3;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignAiResponse>}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.getAiResponsesList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignAiResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignAiResponse, 3));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignAiResponse>} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
*/
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.setAiResponsesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignAiResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.addAiResponses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_order.ConciergeCampaignAiResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.clearAiResponsesList = function() {
  return this.setAiResponsesList([]);
};


/**
 * repeated ConciergeCampaignCitation citations = 4;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCitation>}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCitation, 4));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCitation>} value
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
*/
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCitation}
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.ConciergeCampaignCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignPromptAnalysis} returns this
 */
proto.concierge_order.ConciergeCampaignPromptAnalysis.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCitation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCitation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitation.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
dr: jspb.Message.getFieldWithDefault(msg, 3, 0),
platform: jspb.Message.getFieldWithDefault(msg, 4, 0),
type: jspb.Message.getFieldWithDefault(msg, 5, 0),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCitation}
 */
proto.concierge_order.ConciergeCampaignCitation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCitation;
  return proto.concierge_order.ConciergeCampaignCitation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCitation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCitation}
 */
proto.concierge_order.ConciergeCampaignCitation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDr(value);
      break;
    case 4:
      var value = /** @type {!proto.common.ConciergeCampaignPlatforms} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {!proto.common.ConciergeCampaignCitationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCitation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCitation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCitation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDr();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 dr = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getDr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setDr = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional common.ConciergeCampaignPlatforms platform = 4;
 * @return {!proto.common.ConciergeCampaignPlatforms}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getPlatform = function() {
  return /** @type {!proto.common.ConciergeCampaignPlatforms} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.ConciergeCampaignCitationType type = 5;
 * @return {!proto.common.ConciergeCampaignCitationType}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getType = function() {
  return /** @type {!proto.common.ConciergeCampaignCitationType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignCitationType} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool disabled = 6;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignCitation} returns this
 */
proto.concierge_order.ConciergeCampaignCitation.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignAiResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignAiResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAiResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
platform: jspb.Message.getFieldWithDefault(msg, 1, 0),
responseText: jspb.Message.getFieldWithDefault(msg, 2, ""),
mentioned: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
mentionedRank: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse}
 */
proto.concierge_order.ConciergeCampaignAiResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignAiResponse;
  return proto.concierge_order.ConciergeCampaignAiResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignAiResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse}
 */
proto.concierge_order.ConciergeCampaignAiResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.ConciergeCampaignPlatforms} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseText(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMentioned(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMentionedRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignAiResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignAiResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignAiResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResponseText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMentioned();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMentionedRank();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional common.ConciergeCampaignPlatforms platform = 1;
 * @return {!proto.common.ConciergeCampaignPlatforms}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.getPlatform = function() {
  return /** @type {!proto.common.ConciergeCampaignPlatforms} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string response_text = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.getResponseText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.setResponseText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool mentioned = 3;
 * @return {boolean}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.getMentioned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.setMentioned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 mentioned_rank = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.getMentionedRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignAiResponse} returns this
 */
proto.concierge_order.ConciergeCampaignAiResponse.prototype.setMentionedRank = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignBudgetOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignBudgetOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
totalInvestment: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
totalArticles: jspb.Message.getFieldWithDefault(msg, 2, 0),
monthlyBudget: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
timeline: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignBudgetOverview;
  return proto.concierge_order.ConciergeCampaignBudgetOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignBudgetOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalInvestment(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalArticles(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyBudget(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeline(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignBudgetOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignBudgetOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalInvestment();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTotalArticles();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMonthlyBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTimeline();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional double total_investment = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.getTotalInvestment = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview} returns this
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.setTotalInvestment = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 total_articles = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.getTotalArticles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview} returns this
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.setTotalArticles = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double monthly_budget = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.getMonthlyBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview} returns this
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.setMonthlyBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string timeline = 4;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.getTimeline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignBudgetOverview} returns this
 */
proto.concierge_order.ConciergeCampaignBudgetOverview.prototype.setTimeline = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignContentPlanItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.toObject = function(includeInstance, msg) {
  var f, obj = {
promptId: jspb.Message.getFieldWithDefault(msg, 1, 0),
prompt: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalArticles: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalCost: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.concierge_order.ConciergeCampaignQualityTier.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignContentPlanItem;
  return proto.concierge_order.ConciergeCampaignContentPlanItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPromptId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalArticles(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalCost(value);
      break;
    case 5:
      var value = new proto.concierge_order.ConciergeCampaignQualityTier;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignQualityTier.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignContentPlanItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromptId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalArticles();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalCost();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.concierge_order.ConciergeCampaignQualityTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 prompt_id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.getPromptId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.setPromptId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string prompt = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_articles = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.getTotalArticles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.setTotalArticles = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double total_cost = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.getTotalCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.setTotalCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated ConciergeCampaignQualityTier tiers = 5;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignQualityTier>}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignQualityTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignQualityTier, 5));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignQualityTier>} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
*/
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignQualityTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier}
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.concierge_order.ConciergeCampaignQualityTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanItem} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanItem.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignContentPlanUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignId: jspb.Message.getFieldWithDefault(msg, 1, 0),
promptId: jspb.Message.getFieldWithDefault(msg, 2, 0),
quality: jspb.Message.getFieldWithDefault(msg, 3, 0),
citationsMap: (f = msg.getCitationsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignContentPlanUpdate;
  return proto.concierge_order.ConciergeCampaignContentPlanUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPromptId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 4:
      var value = msg.getCitationsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBool, null, "", false);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignContentPlanUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPromptId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCitationsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBool);
  }
};


/**
 * optional int64 campaign_id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 prompt_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.getPromptId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.setPromptId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.OrderLinkQuality quality = 3;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * map<string, bool> citations = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,boolean>}
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.getCitationsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,boolean>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.concierge_order.ConciergeCampaignContentPlanUpdate} returns this
 */
proto.concierge_order.ConciergeCampaignContentPlanUpdate.prototype.clearCitationsMap = function() {
  this.getCitationsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignQualityTier.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignQualityTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignQualityTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignQualityTier.toObject = function(includeInstance, msg) {
  var f, obj = {
quality: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalArticles: jspb.Message.getFieldWithDefault(msg, 2, 0),
pricePerArticle: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
medianDr: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalCost: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    proto.concierge_order.ConciergeCampaignCitation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier}
 */
proto.concierge_order.ConciergeCampaignQualityTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignQualityTier;
  return proto.concierge_order.ConciergeCampaignQualityTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignQualityTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier}
 */
proto.concierge_order.ConciergeCampaignQualityTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalArticles(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPricePerArticle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedianDr(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalCost(value);
      break;
    case 6:
      var value = new proto.concierge_order.ConciergeCampaignCitation;
      reader.readMessage(value,proto.concierge_order.ConciergeCampaignCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignQualityTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignQualityTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignQualityTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTotalArticles();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPricePerArticle();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMedianDr();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTotalCost();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.concierge_order.ConciergeCampaignCitation.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.OrderLinkQuality quality = 1;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 total_articles = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getTotalArticles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setTotalArticles = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double price_per_article = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getPricePerArticle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setPricePerArticle = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 median_dr = 4;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getMedianDr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setMedianDr = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double total_cost = 5;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getTotalCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setTotalCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated ConciergeCampaignCitation citations = 6;
 * @return {!Array<!proto.concierge_order.ConciergeCampaignCitation>}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.concierge_order.ConciergeCampaignCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConciergeCampaignCitation, 6));
};


/**
 * @param {!Array<!proto.concierge_order.ConciergeCampaignCitation>} value
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
*/
proto.concierge_order.ConciergeCampaignQualityTier.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.concierge_order.ConciergeCampaignCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignCitation}
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.concierge_order.ConciergeCampaignCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignQualityTier} returns this
 */
proto.concierge_order.ConciergeCampaignQualityTier.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignCreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignCreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
optionalFolderId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignCreateRequest}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignCreateRequest;
  return proto.concierge_order.ConciergeCampaignCreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignCreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignCreateRequest}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignCreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignCreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignCreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionalFolderId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCreateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignCreateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 optional_folder_id = 3;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.getOptionalFolderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignCreateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignCreateRequest.prototype.setOptionalFolderId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
url: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignGeneratePromptsRequest;
  return proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 campaign_id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} returns this
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} returns this
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignGeneratePromptsRequest} returns this
 */
proto.concierge_order.ConciergeCampaignGeneratePromptsRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConciergeCampaignUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConciergeCampaignUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
brandName: jspb.Message.getFieldWithDefault(msg, 4, ""),
url: jspb.Message.getFieldWithDefault(msg, 5, ""),
promptsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
platformsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
location: jspb.Message.getFieldWithDefault(msg, 8, ""),
budget: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
autonomy: jspb.Message.getFieldWithDefault(msg, 10, 0),
analyticsFrequency: jspb.Message.getFieldWithDefault(msg, 11, 0),
additionalContentGuidelines: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConciergeCampaignUpdateRequest;
  return proto.concierge_order.ConciergeCampaignUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConciergeCampaignUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPrompts(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlatforms(values[i]);
      }
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBudget(value);
      break;
    case 10:
      var value = /** @type {!proto.common.ConciergeCampaignAutonomy} */ (reader.readEnum());
      msg.setAutonomy(value);
      break;
    case 11:
      var value = /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (reader.readEnum());
      msg.setAnalyticsFrequency(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionalContentGuidelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConciergeCampaignUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConciergeCampaignUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPromptsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getAutonomy();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getAnalyticsFrequency();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getAdditionalContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string brand_name = 4;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string prompts = 6;
 * @return {!Array<string>}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getPromptsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setPromptsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.addPrompts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.clearPromptsList = function() {
  return this.setPromptsList([]);
};


/**
 * repeated common.ConciergeCampaignPlatforms platforms = 7;
 * @return {!Array<!proto.common.ConciergeCampaignPlatforms>}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getPlatformsList = function() {
  return /** @type {!Array<!proto.common.ConciergeCampaignPlatforms>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.common.ConciergeCampaignPlatforms>} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.common.ConciergeCampaignPlatforms} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};


/**
 * optional string location = 8;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional double budget = 9;
 * @return {number}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional common.ConciergeCampaignAutonomy autonomy = 10;
 * @return {!proto.common.ConciergeCampaignAutonomy}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getAutonomy = function() {
  return /** @type {!proto.common.ConciergeCampaignAutonomy} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAutonomy} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setAutonomy = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional common.ConciergeCampaignAnalyticsFrequency analytics_frequency = 11;
 * @return {!proto.common.ConciergeCampaignAnalyticsFrequency}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getAnalyticsFrequency = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalyticsFrequency} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setAnalyticsFrequency = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string additional_content_guidelines = 12;
 * @return {string}
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.getAdditionalContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConciergeCampaignUpdateRequest} returns this
 */
proto.concierge_order.ConciergeCampaignUpdateRequest.prototype.setAdditionalContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderPageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.concierge_order.OrderFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderPageRequest}
 */
proto.concierge_order.OrderPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderPageRequest;
  return proto.concierge_order.OrderPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderPageRequest}
 */
proto.concierge_order.OrderPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = new proto.concierge_order.OrderFilter;
      reader.readMessage(value,proto.concierge_order.OrderFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.OrderFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.concierge_order.OrderPageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderPageRequest} returns this
 */
proto.concierge_order.OrderPageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.concierge_order.OrderPageRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderPageRequest} returns this
 */
proto.concierge_order.OrderPageRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.concierge_order.OrderPageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderPageRequest} returns this
 */
proto.concierge_order.OrderPageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated OrderFilter filters = 4;
 * @return {!Array<!proto.concierge_order.OrderFilter>}
 */
proto.concierge_order.OrderPageRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.concierge_order.OrderFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.OrderFilter, 4));
};


/**
 * @param {!Array<!proto.concierge_order.OrderFilter>} value
 * @return {!proto.concierge_order.OrderPageRequest} returns this
*/
proto.concierge_order.OrderPageRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.OrderFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderFilter}
 */
proto.concierge_order.OrderPageRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.OrderFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderPageRequest} returns this
 */
proto.concierge_order.OrderPageRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderFilter}
 */
proto.concierge_order.OrderFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderFilter;
  return proto.concierge_order.OrderFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderFilter}
 */
proto.concierge_order.OrderFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_order.OrderFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_order.OrderFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderFilter} returns this
 */
proto.concierge_order.OrderFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OrderFilterField field = 2;
 * @return {!proto.concierge_order.OrderFilterField}
 */
proto.concierge_order.OrderFilter.prototype.getField = function() {
  return /** @type {!proto.concierge_order.OrderFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_order.OrderFilterField} value
 * @return {!proto.concierge_order.OrderFilter} returns this
 */
proto.concierge_order.OrderFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.concierge_order.OrderFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderFilter} returns this
 */
proto.concierge_order.OrderFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.concierge_order.OrderFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.concierge_order.OrderFilter} returns this
 */
proto.concierge_order.OrderFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.concierge_order.OrderFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.concierge_order.OrderFilter} returns this
 */
proto.concierge_order.OrderFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
number: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
linksRequested: jspb.Message.getFieldWithDefault(msg, 5, 0),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
dueDate: jspb.Message.getFieldWithDefault(msg, 7, 0),
deliveryType: jspb.Message.getFieldWithDefault(msg, 8, 0),
approvalType: jspb.Message.getFieldWithDefault(msg, 9, 0),
guidelineType: jspb.Message.getFieldWithDefault(msg, 10, 0),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 11, ""),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 12, ""),
launchedAt: jspb.Message.getFieldWithDefault(msg, 13, 0),
ownerId: jspb.Message.getFieldWithDefault(msg, 14, 0),
folderId: jspb.Message.getFieldWithDefault(msg, 15, 0),
deletedAt: jspb.Message.getFieldWithDefault(msg, 16, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 17, 0),
publisherType: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderResponse}
 */
proto.concierge_order.OrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderResponse;
  return proto.concierge_order.OrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderResponse}
 */
proto.concierge_order.OrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 4:
      var value = /** @type {!proto.common.OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLinksRequested(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    case 8:
      var value = /** @type {!proto.common.OrderDeliveryType} */ (reader.readEnum());
      msg.setDeliveryType(value);
      break;
    case 9:
      var value = /** @type {!proto.common.OrderApprovalType} */ (reader.readEnum());
      msg.setApprovalType(value);
      break;
    case 10:
      var value = /** @type {!proto.common.OrderContentGuidelineType} */ (reader.readEnum());
      msg.setGuidelineType(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLaunchedAt(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerId(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFolderId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 18:
      var value = /** @type {!proto.common.OrderPublisherType} */ (reader.readEnum());
      msg.setPublisherType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLinksRequested();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getDueDate();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getApprovalType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getGuidelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLaunchedAt();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getFolderId();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getDeletedAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getPublisherType();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.concierge_order.OrderResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string number = 3;
 * @return {string}
 */
proto.concierge_order.OrderResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.OrderStatus status = 4;
 * @return {!proto.common.OrderStatus}
 */
proto.concierge_order.OrderResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.OrderStatus} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 links_requested = 5;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getLinksRequested = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setLinksRequested = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double price = 6;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 due_date = 7;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setDueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional common.OrderDeliveryType delivery_type = 8;
 * @return {!proto.common.OrderDeliveryType}
 */
proto.concierge_order.OrderResponse.prototype.getDeliveryType = function() {
  return /** @type {!proto.common.OrderDeliveryType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.common.OrderDeliveryType} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional common.OrderApprovalType approval_type = 9;
 * @return {!proto.common.OrderApprovalType}
 */
proto.concierge_order.OrderResponse.prototype.getApprovalType = function() {
  return /** @type {!proto.common.OrderApprovalType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.common.OrderApprovalType} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setApprovalType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional common.OrderContentGuidelineType guideline_type = 10;
 * @return {!proto.common.OrderContentGuidelineType}
 */
proto.concierge_order.OrderResponse.prototype.getGuidelineType = function() {
  return /** @type {!proto.common.OrderContentGuidelineType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.common.OrderContentGuidelineType} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setGuidelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string content_guidelines = 11;
 * @return {string}
 */
proto.concierge_order.OrderResponse.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string domain_specification = 12;
 * @return {string}
 */
proto.concierge_order.OrderResponse.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 launched_at = 13;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getLaunchedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setLaunchedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 owner_id = 14;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 folder_id = 15;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getFolderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 deleted_at = 16;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getDeletedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 total_items = 17;
 * @return {number}
 */
proto.concierge_order.OrderResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional common.OrderPublisherType publisher_type = 18;
 * @return {!proto.common.OrderPublisherType}
 */
proto.concierge_order.OrderResponse.prototype.getPublisherType = function() {
  return /** @type {!proto.common.OrderPublisherType} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.common.OrderPublisherType} value
 * @return {!proto.concierge_order.OrderResponse} returns this
 */
proto.concierge_order.OrderResponse.prototype.setPublisherType = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderCreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderCreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderCreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderCreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
optionalFolderId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderCreateRequest}
 */
proto.concierge_order.OrderCreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderCreateRequest;
  return proto.concierge_order.OrderCreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderCreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderCreateRequest}
 */
proto.concierge_order.OrderCreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderCreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderCreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderCreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderCreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOptionalFolderId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.concierge_order.OrderCreateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderCreateRequest} returns this
 */
proto.concierge_order.OrderCreateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 optional_folder_id = 2;
 * @return {number}
 */
proto.concierge_order.OrderCreateRequest.prototype.getOptionalFolderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderCreateRequest} returns this
 */
proto.concierge_order.OrderCreateRequest.prototype.setOptionalFolderId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderArchiveStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderArchiveStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderArchiveStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
state: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderArchiveStateRequest}
 */
proto.concierge_order.OrderArchiveStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderArchiveStateRequest;
  return proto.concierge_order.OrderArchiveStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderArchiveStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderArchiveStateRequest}
 */
proto.concierge_order.OrderArchiveStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderArchiveStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderArchiveStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderArchiveStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getState();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int64 order_id = 1;
 * @return {number}
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.getOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderArchiveStateRequest} returns this
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderArchiveStateRequest} returns this
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool state = 3;
 * @return {boolean}
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.getState = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.OrderArchiveStateRequest} returns this
 */
proto.concierge_order.OrderArchiveStateRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.CampaignArchiveStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.CampaignArchiveStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignArchiveStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
state: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.CampaignArchiveStateRequest}
 */
proto.concierge_order.CampaignArchiveStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.CampaignArchiveStateRequest;
  return proto.concierge_order.CampaignArchiveStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.CampaignArchiveStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.CampaignArchiveStateRequest}
 */
proto.concierge_order.CampaignArchiveStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.CampaignArchiveStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.CampaignArchiveStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignArchiveStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getState();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int64 campaign_id = 1;
 * @return {number}
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignArchiveStateRequest} returns this
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignArchiveStateRequest} returns this
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool state = 3;
 * @return {boolean}
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.getState = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.CampaignArchiveStateRequest} returns this
 */
proto.concierge_order.CampaignArchiveStateRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.CampaignUpdateBudgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.CampaignUpdateBudgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignUpdateBudgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
budget: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.CampaignUpdateBudgetRequest}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.CampaignUpdateBudgetRequest;
  return proto.concierge_order.CampaignUpdateBudgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.CampaignUpdateBudgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.CampaignUpdateBudgetRequest}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBudget(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.CampaignUpdateBudgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.CampaignUpdateBudgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignUpdateBudgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBudget();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional int64 campaign_id = 1;
 * @return {number}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignUpdateBudgetRequest} returns this
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignUpdateBudgetRequest} returns this
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double budget = 3;
 * @return {number}
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.getBudget = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignUpdateBudgetRequest} returns this
 */
proto.concierge_order.CampaignUpdateBudgetRequest.prototype.setBudget = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
analyticsFrequency: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest;
  return proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (reader.readEnum());
      msg.setAnalyticsFrequency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAnalyticsFrequency();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 campaign_id = 1;
 * @return {number}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} returns this
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} returns this
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.ConciergeCampaignAnalyticsFrequency analytics_frequency = 3;
 * @return {!proto.common.ConciergeCampaignAnalyticsFrequency}
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.getAnalyticsFrequency = function() {
  return /** @type {!proto.common.ConciergeCampaignAnalyticsFrequency} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.ConciergeCampaignAnalyticsFrequency} value
 * @return {!proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest} returns this
 */
proto.concierge_order.CampaignUpdateAnalyticsFrequencyRequest.prototype.setAnalyticsFrequency = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
deliveryType: jspb.Message.getFieldWithDefault(msg, 3, 0),
approvalType: jspb.Message.getFieldWithDefault(msg, 4, 0),
guidelineType: jspb.Message.getFieldWithDefault(msg, 5, 0),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 6, ""),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 7, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 8, 0),
publisherType: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderUpdateRequest}
 */
proto.concierge_order.OrderUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderUpdateRequest;
  return proto.concierge_order.OrderUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderUpdateRequest}
 */
proto.concierge_order.OrderUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {!proto.common.OrderDeliveryType} */ (reader.readEnum());
      msg.setDeliveryType(value);
      break;
    case 4:
      var value = /** @type {!proto.common.OrderApprovalType} */ (reader.readEnum());
      msg.setApprovalType(value);
      break;
    case 5:
      var value = /** @type {!proto.common.OrderContentGuidelineType} */ (reader.readEnum());
      msg.setGuidelineType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 9:
      var value = /** @type {!proto.common.OrderPublisherType} */ (reader.readEnum());
      msg.setPublisherType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getApprovalType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getGuidelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getPublisherType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.OrderDeliveryType delivery_type = 3;
 * @return {!proto.common.OrderDeliveryType}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getDeliveryType = function() {
  return /** @type {!proto.common.OrderDeliveryType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.OrderDeliveryType} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.OrderApprovalType approval_type = 4;
 * @return {!proto.common.OrderApprovalType}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getApprovalType = function() {
  return /** @type {!proto.common.OrderApprovalType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.OrderApprovalType} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setApprovalType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.OrderContentGuidelineType guideline_type = 5;
 * @return {!proto.common.OrderContentGuidelineType}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getGuidelineType = function() {
  return /** @type {!proto.common.OrderContentGuidelineType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.OrderContentGuidelineType} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setGuidelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string domain_specification = 6;
 * @return {string}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string content_guidelines = 7;
 * @return {string}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 workspace_id = 8;
 * @return {number}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional common.OrderPublisherType publisher_type = 9;
 * @return {!proto.common.OrderPublisherType}
 */
proto.concierge_order.OrderUpdateRequest.prototype.getPublisherType = function() {
  return /** @type {!proto.common.OrderPublisherType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.common.OrderPublisherType} value
 * @return {!proto.concierge_order.OrderUpdateRequest} returns this
 */
proto.concierge_order.OrderUpdateRequest.prototype.setPublisherType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderRenameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderRenameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderRenameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderRenameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderRenameRequest}
 */
proto.concierge_order.OrderRenameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderRenameRequest;
  return proto.concierge_order.OrderRenameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderRenameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderRenameRequest}
 */
proto.concierge_order.OrderRenameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderRenameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderRenameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderRenameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderRenameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderRenameRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderRenameRequest} returns this
 */
proto.concierge_order.OrderRenameRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.OrderRenameRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderRenameRequest} returns this
 */
proto.concierge_order.OrderRenameRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.concierge_order.OrderRenameRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderRenameRequest} returns this
 */
proto.concierge_order.OrderRenameRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderDetailsResponse.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
deliveryType: jspb.Message.getFieldWithDefault(msg, 4, 0),
approvalType: jspb.Message.getFieldWithDefault(msg, 5, 0),
guidelineType: jspb.Message.getFieldWithDefault(msg, 6, 0),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
discount: jspb.Message.getFieldWithDefault(msg, 8, 0),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 9, ""),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 10, ""),
statList: jspb.Message.toObjectList(msg.getStatList(),
    proto.concierge_order.OrderStatistics.toObject, includeInstance),
firstOrder: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
createdAt: jspb.Message.getFieldWithDefault(msg, 13, 0),
publisherType: jspb.Message.getFieldWithDefault(msg, 14, 0),
bonusAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
bonusExpiresAt: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderDetailsResponse}
 */
proto.concierge_order.OrderDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderDetailsResponse;
  return proto.concierge_order.OrderDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderDetailsResponse}
 */
proto.concierge_order.OrderDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {!proto.common.OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {!proto.common.OrderDeliveryType} */ (reader.readEnum());
      msg.setDeliveryType(value);
      break;
    case 5:
      var value = /** @type {!proto.common.OrderApprovalType} */ (reader.readEnum());
      msg.setApprovalType(value);
      break;
    case 6:
      var value = /** @type {!proto.common.OrderContentGuidelineType} */ (reader.readEnum());
      msg.setGuidelineType(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscount(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    case 11:
      var value = new proto.concierge_order.OrderStatistics;
      reader.readMessage(value,proto.concierge_order.OrderStatistics.deserializeBinaryFromReader);
      msg.addStat(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirstOrder(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 14:
      var value = /** @type {!proto.common.OrderPublisherType} */ (reader.readEnum());
      msg.setPublisherType(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBonusAmount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBonusExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getApprovalType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getGuidelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.concierge_order.OrderStatistics.serializeBinaryToWriter
    );
  }
  f = message.getFirstOrder();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getPublisherType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getBonusAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getBonusExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.OrderStatus status = 3;
 * @return {!proto.common.OrderStatus}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.OrderStatus} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.OrderDeliveryType delivery_type = 4;
 * @return {!proto.common.OrderDeliveryType}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getDeliveryType = function() {
  return /** @type {!proto.common.OrderDeliveryType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.OrderDeliveryType} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.OrderApprovalType approval_type = 5;
 * @return {!proto.common.OrderApprovalType}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getApprovalType = function() {
  return /** @type {!proto.common.OrderApprovalType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.OrderApprovalType} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setApprovalType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.OrderContentGuidelineType guideline_type = 6;
 * @return {!proto.common.OrderContentGuidelineType}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getGuidelineType = function() {
  return /** @type {!proto.common.OrderContentGuidelineType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.OrderContentGuidelineType} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setGuidelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional double price = 7;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 discount = 8;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string domain_specification = 9;
 * @return {string}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string content_guidelines = 10;
 * @return {string}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated OrderStatistics stat = 11;
 * @return {!Array<!proto.concierge_order.OrderStatistics>}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getStatList = function() {
  return /** @type{!Array<!proto.concierge_order.OrderStatistics>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.OrderStatistics, 11));
};


/**
 * @param {!Array<!proto.concierge_order.OrderStatistics>} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
*/
proto.concierge_order.OrderDetailsResponse.prototype.setStatList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.concierge_order.OrderStatistics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderStatistics}
 */
proto.concierge_order.OrderDetailsResponse.prototype.addStat = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.concierge_order.OrderStatistics, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.clearStatList = function() {
  return this.setStatList([]);
};


/**
 * optional bool first_order = 12;
 * @return {boolean}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getFirstOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setFirstOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional int64 created_at = 13;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional common.OrderPublisherType publisher_type = 14;
 * @return {!proto.common.OrderPublisherType}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getPublisherType = function() {
  return /** @type {!proto.common.OrderPublisherType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.common.OrderPublisherType} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setPublisherType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional double bonus_amount = 15;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getBonusAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setBonusAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional int64 bonus_expires_at = 16;
 * @return {number}
 */
proto.concierge_order.OrderDetailsResponse.prototype.getBonusExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderDetailsResponse} returns this
 */
proto.concierge_order.OrderDetailsResponse.prototype.setBonusExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderStatistics.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderStatistics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderStatistics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderStatistics.toObject = function(includeInstance, msg) {
  var f, obj = {
linkQuality: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0),
itemsWithContentGuidelines: jspb.Message.getFieldWithDefault(msg, 3, 0),
itemsWithDomainSpecification: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderStatistics}
 */
proto.concierge_order.OrderStatistics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderStatistics;
  return proto.concierge_order.OrderStatistics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderStatistics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderStatistics}
 */
proto.concierge_order.OrderStatistics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setLinkQuality(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemsWithContentGuidelines(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemsWithDomainSpecification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderStatistics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderStatistics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderStatistics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderStatistics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getItemsWithContentGuidelines();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getItemsWithDomainSpecification();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional common.OrderLinkQuality link_quality = 1;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.OrderStatistics.prototype.getLinkQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.OrderStatistics} returns this
 */
proto.concierge_order.OrderStatistics.prototype.setLinkQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 total_items = 2;
 * @return {number}
 */
proto.concierge_order.OrderStatistics.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderStatistics} returns this
 */
proto.concierge_order.OrderStatistics.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 items_with_content_guidelines = 3;
 * @return {number}
 */
proto.concierge_order.OrderStatistics.prototype.getItemsWithContentGuidelines = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderStatistics} returns this
 */
proto.concierge_order.OrderStatistics.prototype.setItemsWithContentGuidelines = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 items_with_domain_specification = 4;
 * @return {number}
 */
proto.concierge_order.OrderStatistics.prototype.getItemsWithDomainSpecification = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderStatistics} returns this
 */
proto.concierge_order.OrderStatistics.prototype.setItemsWithDomainSpecification = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderItemContainerRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderItemContainerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderItemContainerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemContainerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_order.OrderItemRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderItemContainerRequest}
 */
proto.concierge_order.OrderItemContainerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderItemContainerRequest;
  return proto.concierge_order.OrderItemContainerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderItemContainerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderItemContainerRequest}
 */
proto.concierge_order.OrderItemContainerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = new proto.concierge_order.OrderItemRequest;
      reader.readMessage(value,proto.concierge_order.OrderItemRequest.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderItemContainerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderItemContainerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemContainerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_order.OrderItemRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 order_id = 1;
 * @return {number}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.getOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemContainerRequest} returns this
 */
proto.concierge_order.OrderItemContainerRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemContainerRequest} returns this
 */
proto.concierge_order.OrderItemContainerRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated OrderItemRequest items = 3;
 * @return {!Array<!proto.concierge_order.OrderItemRequest>}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_order.OrderItemRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.OrderItemRequest, 3));
};


/**
 * @param {!Array<!proto.concierge_order.OrderItemRequest>} value
 * @return {!proto.concierge_order.OrderItemContainerRequest} returns this
*/
proto.concierge_order.OrderItemContainerRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_order.OrderItemRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderItemRequest}
 */
proto.concierge_order.OrderItemContainerRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_order.OrderItemRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderItemContainerRequest} returns this
 */
proto.concierge_order.OrderItemContainerRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
requestedTargetUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedAnchor: jspb.Message.getFieldWithDefault(msg, 4, ""),
quality: jspb.Message.getFieldWithDefault(msg, 5, 0),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 8, ""),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderItemRequest}
 */
proto.concierge_order.OrderItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderItemRequest;
  return proto.concierge_order.OrderItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderItemRequest}
 */
proto.concierge_order.OrderItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedTargetUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedAnchor(value);
      break;
    case 5:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRequestedTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestedAnchor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.concierge_order.OrderItemRequest.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.concierge_order.OrderItemRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string requested_target_url = 3;
 * @return {string}
 */
proto.concierge_order.OrderItemRequest.prototype.getRequestedTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setRequestedTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requested_anchor = 4;
 * @return {string}
 */
proto.concierge_order.OrderItemRequest.prototype.getRequestedAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setRequestedAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.OrderLinkQuality quality = 5;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.OrderItemRequest.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string domain_specification = 8;
 * @return {string}
 */
proto.concierge_order.OrderItemRequest.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string content_guidelines = 9;
 * @return {string}
 */
proto.concierge_order.OrderItemRequest.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemRequest} returns this
 */
proto.concierge_order.OrderItemRequest.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderItemChangeStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderItemChangeStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemChangeStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
optReason: (f = msg.getOptReason()) && common_pb.OrderItemStatusReason.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest}
 */
proto.concierge_order.OrderItemChangeStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderItemChangeStatusRequest;
  return proto.concierge_order.OrderItemChangeStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderItemChangeStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest}
 */
proto.concierge_order.OrderItemChangeStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.OrderItemStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new common_pb.OrderItemStatusReason;
      reader.readMessage(value,common_pb.OrderItemStatusReason.deserializeBinaryFromReader);
      msg.setOptReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderItemChangeStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderItemChangeStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemChangeStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOptReason();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.OrderItemStatusReason.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest} returns this
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest} returns this
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.OrderItemStatus status = 3;
 * @return {!proto.common.OrderItemStatus}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.common.OrderItemStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.OrderItemStatus} value
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest} returns this
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.OrderItemStatusReason opt_reason = 4;
 * @return {?proto.common.OrderItemStatusReason}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.getOptReason = function() {
  return /** @type{?proto.common.OrderItemStatusReason} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderItemStatusReason, 4));
};


/**
 * @param {?proto.common.OrderItemStatusReason|undefined} value
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest} returns this
*/
proto.concierge_order.OrderItemChangeStatusRequest.prototype.setOptReason = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_order.OrderItemChangeStatusRequest} returns this
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.clearOptReason = function() {
  return this.setOptReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_order.OrderItemChangeStatusRequest.prototype.hasOptReason = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.DomainApprovalReviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.DomainApprovalReviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderItemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.DomainApprovalReviewRequest}
 */
proto.concierge_order.DomainApprovalReviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.DomainApprovalReviewRequest;
  return proto.concierge_order.DomainApprovalReviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.DomainApprovalReviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.DomainApprovalReviewRequest}
 */
proto.concierge_order.DomainApprovalReviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.DomainApprovalReviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.DomainApprovalReviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 order_item_id = 1;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.DomainApprovalReviewResponse.repeatedFields_ = [10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.DomainApprovalReviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.DomainApprovalReviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
orderItemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
placementNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
requestedTargetUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedAnchor: jspb.Message.getFieldWithDefault(msg, 4, ""),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
quality: jspb.Message.getFieldWithDefault(msg, 6, 0),
triesLeft: jspb.Message.getFieldWithDefault(msg, 7, 0),
rejectionLimit: jspb.Message.getFieldWithDefault(msg, 8, 0),
sentAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
domainsList: jspb.Message.toObjectList(msg.getDomainsList(),
    proto.concierge_order.SuggestedDomain.toObject, includeInstance),
rejectedEarlierList: jspb.Message.toObjectList(msg.getRejectedEarlierList(),
    proto.concierge_order.RejectedDomainHistory.toObject, includeInstance),
refundsIfAllRejected: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.DomainApprovalReviewResponse}
 */
proto.concierge_order.DomainApprovalReviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.DomainApprovalReviewResponse;
  return proto.concierge_order.DomainApprovalReviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.DomainApprovalReviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.DomainApprovalReviewResponse}
 */
proto.concierge_order.DomainApprovalReviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlacementNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedTargetUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedAnchor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTriesLeft(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRejectionLimit(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSentAt(value);
      break;
    case 10:
      var value = new proto.concierge_order.SuggestedDomain;
      reader.readMessage(value,proto.concierge_order.SuggestedDomain.deserializeBinaryFromReader);
      msg.addDomains(value);
      break;
    case 11:
      var value = new proto.concierge_order.RejectedDomainHistory;
      reader.readMessage(value,proto.concierge_order.RejectedDomainHistory.deserializeBinaryFromReader);
      msg.addRejectedEarlier(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefundsIfAllRejected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.DomainApprovalReviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.DomainApprovalReviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPlacementNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestedTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestedAnchor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTriesLeft();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getRejectionLimit();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getSentAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.concierge_order.SuggestedDomain.serializeBinaryToWriter
    );
  }
  f = message.getRejectedEarlierList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.concierge_order.RejectedDomainHistory.serializeBinaryToWriter
    );
  }
  f = message.getRefundsIfAllRejected();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional int64 order_item_id = 1;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string placement_number = 2;
 * @return {string}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getPlacementNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setPlacementNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string requested_target_url = 3;
 * @return {string}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getRequestedTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setRequestedTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requested_anchor = 4;
 * @return {string}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getRequestedAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setRequestedAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double price = 5;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional common.OrderLinkQuality quality = 6;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 tries_left = 7;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getTriesLeft = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setTriesLeft = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 rejection_limit = 8;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getRejectionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setRejectionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 sent_at = 9;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getSentAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setSentAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated SuggestedDomain domains = 10;
 * @return {!Array<!proto.concierge_order.SuggestedDomain>}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getDomainsList = function() {
  return /** @type{!Array<!proto.concierge_order.SuggestedDomain>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.SuggestedDomain, 10));
};


/**
 * @param {!Array<!proto.concierge_order.SuggestedDomain>} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
*/
proto.concierge_order.DomainApprovalReviewResponse.prototype.setDomainsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.concierge_order.SuggestedDomain=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.SuggestedDomain}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.addDomains = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.concierge_order.SuggestedDomain, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.clearDomainsList = function() {
  return this.setDomainsList([]);
};


/**
 * repeated RejectedDomainHistory rejected_earlier = 11;
 * @return {!Array<!proto.concierge_order.RejectedDomainHistory>}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getRejectedEarlierList = function() {
  return /** @type{!Array<!proto.concierge_order.RejectedDomainHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.RejectedDomainHistory, 11));
};


/**
 * @param {!Array<!proto.concierge_order.RejectedDomainHistory>} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
*/
proto.concierge_order.DomainApprovalReviewResponse.prototype.setRejectedEarlierList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.concierge_order.RejectedDomainHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.RejectedDomainHistory}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.addRejectedEarlier = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.concierge_order.RejectedDomainHistory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.clearRejectedEarlierList = function() {
  return this.setRejectedEarlierList([]);
};


/**
 * optional bool refunds_if_all_rejected = 12;
 * @return {boolean}
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.getRefundsIfAllRejected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.DomainApprovalReviewResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewResponse.prototype.setRefundsIfAllRejected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.SuggestedDomain.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.SuggestedDomain.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.SuggestedDomain} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SuggestedDomain.toObject = function(includeInstance, msg) {
  var f, obj = {
suggestionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
domainRating: jspb.Message.getFieldWithDefault(msg, 3, 0),
domainTraffic: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
hasDomainRating: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
hasDomainTraffic: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.SuggestedDomain}
 */
proto.concierge_order.SuggestedDomain.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.SuggestedDomain;
  return proto.concierge_order.SuggestedDomain.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.SuggestedDomain} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.SuggestedDomain}
 */
proto.concierge_order.SuggestedDomain.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuggestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDomainRating(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDomainTraffic(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDomainRating(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDomainTraffic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.SuggestedDomain.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.SuggestedDomain.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.SuggestedDomain} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.SuggestedDomain.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestionId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDomainRating();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDomainTraffic();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHasDomainRating();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getHasDomainTraffic();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int64 suggestion_id = 1;
 * @return {number}
 */
proto.concierge_order.SuggestedDomain.prototype.getSuggestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setSuggestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.concierge_order.SuggestedDomain.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 domain_rating = 3;
 * @return {number}
 */
proto.concierge_order.SuggestedDomain.prototype.getDomainRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setDomainRating = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double domain_traffic = 4;
 * @return {number}
 */
proto.concierge_order.SuggestedDomain.prototype.getDomainTraffic = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setDomainTraffic = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool has_domain_rating = 5;
 * @return {boolean}
 */
proto.concierge_order.SuggestedDomain.prototype.getHasDomainRating = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setHasDomainRating = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool has_domain_traffic = 6;
 * @return {boolean}
 */
proto.concierge_order.SuggestedDomain.prototype.getHasDomainTraffic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.SuggestedDomain} returns this
 */
proto.concierge_order.SuggestedDomain.prototype.setHasDomainTraffic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.RejectedDomainHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.RejectedDomainHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.RejectedDomainHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RejectedDomainHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
domain: jspb.Message.getFieldWithDefault(msg, 1, ""),
reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
rejectedAt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.RejectedDomainHistory}
 */
proto.concierge_order.RejectedDomainHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.RejectedDomainHistory;
  return proto.concierge_order.RejectedDomainHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.RejectedDomainHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.RejectedDomainHistory}
 */
proto.concierge_order.RejectedDomainHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRejectedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.RejectedDomainHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.RejectedDomainHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.RejectedDomainHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RejectedDomainHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRejectedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string domain = 1;
 * @return {string}
 */
proto.concierge_order.RejectedDomainHistory.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.RejectedDomainHistory} returns this
 */
proto.concierge_order.RejectedDomainHistory.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.concierge_order.RejectedDomainHistory.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.RejectedDomainHistory} returns this
 */
proto.concierge_order.RejectedDomainHistory.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 rejected_at = 3;
 * @return {number}
 */
proto.concierge_order.RejectedDomainHistory.prototype.getRejectedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.RejectedDomainHistory} returns this
 */
proto.concierge_order.RejectedDomainHistory.prototype.setRejectedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.DomainApprovalReviewSubmitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderItemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
decisionsList: jspb.Message.toObjectList(msg.getDecisionsList(),
    proto.concierge_order.DomainDecision.toObject, includeInstance),
optionalComment: jspb.Message.getFieldWithDefault(msg, 4, ""),
primarySuggestionId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.DomainApprovalReviewSubmitRequest;
  return proto.concierge_order.DomainApprovalReviewSubmitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = new proto.concierge_order.DomainDecision;
      reader.readMessage(value,proto.concierge_order.DomainDecision.deserializeBinaryFromReader);
      msg.addDecisions(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalComment(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrimarySuggestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.DomainApprovalReviewSubmitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDecisionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_order.DomainDecision.serializeBinaryToWriter
    );
  }
  f = message.getOptionalComment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrimarySuggestionId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 order_item_id = 1;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated DomainDecision decisions = 3;
 * @return {!Array<!proto.concierge_order.DomainDecision>}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.getDecisionsList = function() {
  return /** @type{!Array<!proto.concierge_order.DomainDecision>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.DomainDecision, 3));
};


/**
 * @param {!Array<!proto.concierge_order.DomainDecision>} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
*/
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.setDecisionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_order.DomainDecision=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.DomainDecision}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.addDecisions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_order.DomainDecision, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.clearDecisionsList = function() {
  return this.setDecisionsList([]);
};


/**
 * optional string optional_comment = 4;
 * @return {string}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.getOptionalComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.setOptionalComment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 primary_suggestion_id = 5;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.getPrimarySuggestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitRequest} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitRequest.prototype.setPrimarySuggestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.DomainDecision.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.DomainDecision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.DomainDecision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainDecision.toObject = function(includeInstance, msg) {
  var f, obj = {
suggestionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
approved: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
optionalReason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.DomainDecision}
 */
proto.concierge_order.DomainDecision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.DomainDecision;
  return proto.concierge_order.DomainDecision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.DomainDecision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.DomainDecision}
 */
proto.concierge_order.DomainDecision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuggestionId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApproved(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.DomainDecision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.DomainDecision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.DomainDecision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainDecision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestionId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getApproved();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOptionalReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 suggestion_id = 1;
 * @return {number}
 */
proto.concierge_order.DomainDecision.prototype.getSuggestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainDecision} returns this
 */
proto.concierge_order.DomainDecision.prototype.setSuggestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool approved = 2;
 * @return {boolean}
 */
proto.concierge_order.DomainDecision.prototype.getApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.DomainDecision} returns this
 */
proto.concierge_order.DomainDecision.prototype.setApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string optional_reason = 3;
 * @return {string}
 */
proto.concierge_order.DomainDecision.prototype.getOptionalReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.DomainDecision} returns this
 */
proto.concierge_order.DomainDecision.prototype.setOptionalReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.DomainApprovalReviewSubmitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
approvedCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
rejectedCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
outcome: jspb.Message.getFieldWithDefault(msg, 3, 0),
triesLeft: jspb.Message.getFieldWithDefault(msg, 4, 0),
optionalNextPendingOrderItemId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.DomainApprovalReviewSubmitResponse;
  return proto.concierge_order.DomainApprovalReviewSubmitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setApprovedCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRejectedCount(value);
      break;
    case 3:
      var value = /** @type {!proto.concierge_order.DomainApprovalOutcome} */ (reader.readEnum());
      msg.setOutcome(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTriesLeft(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalNextPendingOrderItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.DomainApprovalReviewSubmitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.DomainApprovalReviewSubmitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApprovedCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRejectedCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOutcome();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTriesLeft();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOptionalNextPendingOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 approved_count = 1;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.getApprovedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.setApprovedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 rejected_count = 2;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.getRejectedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.setRejectedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DomainApprovalOutcome outcome = 3;
 * @return {!proto.concierge_order.DomainApprovalOutcome}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.getOutcome = function() {
  return /** @type {!proto.concierge_order.DomainApprovalOutcome} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.concierge_order.DomainApprovalOutcome} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 tries_left = 4;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.getTriesLeft = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.setTriesLeft = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 optional_next_pending_order_item_id = 5;
 * @return {number}
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.getOptionalNextPendingOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.DomainApprovalReviewSubmitResponse} returns this
 */
proto.concierge_order.DomainApprovalReviewSubmitResponse.prototype.setOptionalNextPendingOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
uid: jspb.Message.getFieldWithDefault(msg, 2, ""),
requestedTargetUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedAnchor: jspb.Message.getFieldWithDefault(msg, 4, ""),
quality: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 7, ""),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 8, ""),
totalItems: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderItemResponse}
 */
proto.concierge_order.OrderItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderItemResponse;
  return proto.concierge_order.OrderItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderItemResponse}
 */
proto.concierge_order.OrderItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedTargetUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedAnchor(value);
      break;
    case 5:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestedTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestedAnchor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderItemResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string uid = 2;
 * @return {string}
 */
proto.concierge_order.OrderItemResponse.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string requested_target_url = 3;
 * @return {string}
 */
proto.concierge_order.OrderItemResponse.prototype.getRequestedTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setRequestedTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requested_anchor = 4;
 * @return {string}
 */
proto.concierge_order.OrderItemResponse.prototype.getRequestedAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setRequestedAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.OrderLinkQuality quality = 5;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.OrderItemResponse.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.concierge_order.OrderItemResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string domain_specification = 7;
 * @return {string}
 */
proto.concierge_order.OrderItemResponse.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string content_guidelines = 8;
 * @return {string}
 */
proto.concierge_order.OrderItemResponse.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 total_items = 9;
 * @return {number}
 */
proto.concierge_order.OrderItemResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderItemResponse} returns this
 */
proto.concierge_order.OrderItemResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderPricingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderPricingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderPricingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderPricingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
linkQuality: jspb.Message.getFieldWithDefault(msg, 2, 0),
trafficRange: jspb.Message.getFieldWithDefault(msg, 3, ""),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderPricingResponse}
 */
proto.concierge_order.OrderPricingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderPricingResponse;
  return proto.concierge_order.OrderPricingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderPricingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderPricingResponse}
 */
proto.concierge_order.OrderPricingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setLinkQuality(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrafficRange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderPricingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderPricingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderPricingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderPricingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLinkQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTrafficRange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_order.OrderPricingResponse.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderPricingResponse} returns this
 */
proto.concierge_order.OrderPricingResponse.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.OrderLinkQuality link_quality = 2;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.OrderPricingResponse.prototype.getLinkQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.OrderPricingResponse} returns this
 */
proto.concierge_order.OrderPricingResponse.prototype.setLinkQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string traffic_range = 3;
 * @return {string}
 */
proto.concierge_order.OrderPricingResponse.prototype.getTrafficRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderPricingResponse} returns this
 */
proto.concierge_order.OrderPricingResponse.prototype.setTrafficRange = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double price = 4;
 * @return {number}
 */
proto.concierge_order.OrderPricingResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderPricingResponse} returns this
 */
proto.concierge_order.OrderPricingResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderBacklinkPageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderBacklinkPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderBacklinkPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.concierge_order.OrderBacklinkFilter.toObject, includeInstance),
sortField: jspb.Message.getFieldWithDefault(msg, 5, 0),
sortDirection: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderBacklinkPageRequest}
 */
proto.concierge_order.OrderBacklinkPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderBacklinkPageRequest;
  return proto.concierge_order.OrderBacklinkPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderBacklinkPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderBacklinkPageRequest}
 */
proto.concierge_order.OrderBacklinkPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = new proto.concierge_order.OrderBacklinkFilter;
      reader.readMessage(value,proto.concierge_order.OrderBacklinkFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    case 5:
      var value = /** @type {!proto.concierge_order.OrderBacklinkSortProto} */ (reader.readEnum());
      msg.setSortField(value);
      break;
    case 6:
      var value = /** @type {!proto.common.SortDirection} */ (reader.readEnum());
      msg.setSortDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderBacklinkPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderBacklinkPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.OrderBacklinkFilter.serializeBinaryToWriter
    );
  }
  f = message.getSortField();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSortDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated OrderBacklinkFilter filters = 4;
 * @return {!Array<!proto.concierge_order.OrderBacklinkFilter>}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.concierge_order.OrderBacklinkFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.OrderBacklinkFilter, 4));
};


/**
 * @param {!Array<!proto.concierge_order.OrderBacklinkFilter>} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
*/
proto.concierge_order.OrderBacklinkPageRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.OrderBacklinkFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderBacklinkFilter}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.OrderBacklinkFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};


/**
 * optional OrderBacklinkSortProto sort_field = 5;
 * @return {!proto.concierge_order.OrderBacklinkSortProto}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getSortField = function() {
  return /** @type {!proto.concierge_order.OrderBacklinkSortProto} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.concierge_order.OrderBacklinkSortProto} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.setSortField = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.SortDirection sort_direction = 6;
 * @return {!proto.common.SortDirection}
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.getSortDirection = function() {
  return /** @type {!proto.common.SortDirection} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.SortDirection} value
 * @return {!proto.concierge_order.OrderBacklinkPageRequest} returns this
 */
proto.concierge_order.OrderBacklinkPageRequest.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderBacklinkFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderBacklinkFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderBacklinkFilter}
 */
proto.concierge_order.OrderBacklinkFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderBacklinkFilter;
  return proto.concierge_order.OrderBacklinkFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderBacklinkFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderBacklinkFilter}
 */
proto.concierge_order.OrderBacklinkFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_order.OrderBacklinkFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderBacklinkFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderBacklinkFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkFilter} returns this
 */
proto.concierge_order.OrderBacklinkFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OrderBacklinkFilterField field = 2;
 * @return {!proto.concierge_order.OrderBacklinkFilterField}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.getField = function() {
  return /** @type {!proto.concierge_order.OrderBacklinkFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_order.OrderBacklinkFilterField} value
 * @return {!proto.concierge_order.OrderBacklinkFilter} returns this
 */
proto.concierge_order.OrderBacklinkFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkFilter} returns this
 */
proto.concierge_order.OrderBacklinkFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.concierge_order.OrderBacklinkFilter} returns this
 */
proto.concierge_order.OrderBacklinkFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.concierge_order.OrderBacklinkFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.concierge_order.OrderBacklinkFilter} returns this
 */
proto.concierge_order.OrderBacklinkFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderBacklinkExportRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderBacklinkExportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderBacklinkExportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkExportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
selectedIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.concierge_order.OrderBacklinkFilter.toObject, includeInstance),
workspaceId: jspb.Message.getFieldWithDefault(msg, 4, 0),
sortField: jspb.Message.getFieldWithDefault(msg, 5, 0),
sortDirection: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderBacklinkExportRequest}
 */
proto.concierge_order.OrderBacklinkExportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderBacklinkExportRequest;
  return proto.concierge_order.OrderBacklinkExportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderBacklinkExportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderBacklinkExportRequest}
 */
proto.concierge_order.OrderBacklinkExportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.concierge_order.OrderBacklinkExportRequest.ExportType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSelectedIds(values[i]);
      }
      break;
    case 3:
      var value = new proto.concierge_order.OrderBacklinkFilter;
      reader.readMessage(value,proto.concierge_order.OrderBacklinkFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 5:
      var value = /** @type {!proto.concierge_order.OrderBacklinkSortProto} */ (reader.readEnum());
      msg.setSortField(value);
      break;
    case 6:
      var value = /** @type {!proto.common.SortDirection} */ (reader.readEnum());
      msg.setSortDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderBacklinkExportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderBacklinkExportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkExportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSelectedIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_order.OrderBacklinkFilter.serializeBinaryToWriter
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSortField();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSortDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.concierge_order.OrderBacklinkExportRequest.ExportType = {
  ALL: 0,
  FILTERED: 1,
  SELECTED: 2
};

/**
 * optional ExportType type = 1;
 * @return {!proto.concierge_order.OrderBacklinkExportRequest.ExportType}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getType = function() {
  return /** @type {!proto.concierge_order.OrderBacklinkExportRequest.ExportType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.concierge_order.OrderBacklinkExportRequest.ExportType} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated int64 selected_ids = 2;
 * @return {!Array<number>}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getSelectedIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.setSelectedIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.addSelectedIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.clearSelectedIdsList = function() {
  return this.setSelectedIdsList([]);
};


/**
 * repeated OrderBacklinkFilter filters = 3;
 * @return {!Array<!proto.concierge_order.OrderBacklinkFilter>}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.concierge_order.OrderBacklinkFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.OrderBacklinkFilter, 3));
};


/**
 * @param {!Array<!proto.concierge_order.OrderBacklinkFilter>} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
*/
proto.concierge_order.OrderBacklinkExportRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_order.OrderBacklinkFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderBacklinkFilter}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_order.OrderBacklinkFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};


/**
 * optional int64 workspace_id = 4;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional OrderBacklinkSortProto sort_field = 5;
 * @return {!proto.concierge_order.OrderBacklinkSortProto}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getSortField = function() {
  return /** @type {!proto.concierge_order.OrderBacklinkSortProto} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.concierge_order.OrderBacklinkSortProto} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.setSortField = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.SortDirection sort_direction = 6;
 * @return {!proto.common.SortDirection}
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.getSortDirection = function() {
  return /** @type {!proto.common.SortDirection} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.SortDirection} value
 * @return {!proto.concierge_order.OrderBacklinkExportRequest} returns this
 */
proto.concierge_order.OrderBacklinkExportRequest.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.CampaignExportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.CampaignExportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.CampaignExportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignExportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
campaignId: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.CampaignExportRequest}
 */
proto.concierge_order.CampaignExportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.CampaignExportRequest;
  return proto.concierge_order.CampaignExportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.CampaignExportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.CampaignExportRequest}
 */
proto.concierge_order.CampaignExportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.concierge_order.CampaignExportRequest.ExportType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.CampaignExportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.CampaignExportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.CampaignExportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.CampaignExportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCampaignId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.concierge_order.CampaignExportRequest.ExportType = {
  VISIBILITY: 0,
  ACTION_PLAN: 1
};

/**
 * optional ExportType type = 1;
 * @return {!proto.concierge_order.CampaignExportRequest.ExportType}
 */
proto.concierge_order.CampaignExportRequest.prototype.getType = function() {
  return /** @type {!proto.concierge_order.CampaignExportRequest.ExportType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.concierge_order.CampaignExportRequest.ExportType} value
 * @return {!proto.concierge_order.CampaignExportRequest} returns this
 */
proto.concierge_order.CampaignExportRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 campaign_id = 2;
 * @return {number}
 */
proto.concierge_order.CampaignExportRequest.prototype.getCampaignId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignExportRequest} returns this
 */
proto.concierge_order.CampaignExportRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.concierge_order.CampaignExportRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.CampaignExportRequest} returns this
 */
proto.concierge_order.CampaignExportRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.OrderBacklinkResponse.repeatedFields_ = [28,40];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.OrderBacklinkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.OrderBacklinkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
number: jspb.Message.getFieldWithDefault(msg, 2, ""),
orderTitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
orderNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
discount: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 7, 0),
quality: jspb.Message.getFieldWithDefault(msg, 8, 0),
launchedAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
deadlineAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
approvedAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
liveAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
ownerId: jspb.Message.getFieldWithDefault(msg, 13, 0),
requestedTargetUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
requestedAnchor: jspb.Message.getFieldWithDefault(msg, 15, ""),
publishedTargetUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
publishedAnchor: jspb.Message.getFieldWithDefault(msg, 17, ""),
domainRating: jspb.Message.getFieldWithDefault(msg, 18, 0),
domainTraffic: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
isLastRejectTry: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
totalItems: jspb.Message.getFieldWithDefault(msg, 21, 0),
deliveryType: jspb.Message.getFieldWithDefault(msg, 22, 0),
approvalType: jspb.Message.getFieldWithDefault(msg, 23, 0),
contentGuidelines: jspb.Message.getFieldWithDefault(msg, 24, ""),
guidelineType: jspb.Message.getFieldWithDefault(msg, 25, 0),
domainSpecification: jspb.Message.getFieldWithDefault(msg, 26, ""),
rejectedCount: jspb.Message.getFieldWithDefault(msg, 27, 0),
rejectionDatesList: (f = jspb.Message.getRepeatedField(msg, 28)) == null ? undefined : f,
optionalConcernStatus: jspb.Message.getFieldWithDefault(msg, 29, 0),
optionalConcernId: jspb.Message.getFieldWithDefault(msg, 30, 0),
publisherType: jspb.Message.getFieldWithDefault(msg, 31, 0),
pendingDomainCount: jspb.Message.getFieldWithDefault(msg, 32, 0),
triesLeft: jspb.Message.getFieldWithDefault(msg, 33, 0),
domainApprovalState: jspb.Message.getFieldWithDefault(msg, 34, 0),
approvedDomain: jspb.Message.getFieldWithDefault(msg, 35, ""),
approvedBackupCount: jspb.Message.getFieldWithDefault(msg, 36, 0),
hasDomainRating: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
hasDomainTraffic: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
refundAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 39, 0.0),
approvedBackupDomainsList: (f = jspb.Message.getRepeatedField(msg, 40)) == null ? undefined : f,
indexedAt: jspb.Message.getFieldWithDefault(msg, 41, 0),
briefDocumentUrl: jspb.Message.getFieldWithDefault(msg, 42, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.OrderBacklinkResponse}
 */
proto.concierge_order.OrderBacklinkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.OrderBacklinkResponse;
  return proto.concierge_order.OrderBacklinkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.OrderBacklinkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.OrderBacklinkResponse}
 */
proto.concierge_order.OrderBacklinkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiscount(value);
      break;
    case 7:
      var value = /** @type {!proto.common.OrderItemStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {!proto.common.OrderLinkQuality} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLaunchedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeadlineAt(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApprovedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLiveAt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedTargetUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedAnchor(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedTargetUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedAnchor(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDomainRating(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDomainTraffic(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLastRejectTry(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 22:
      var value = /** @type {!proto.common.OrderDeliveryType} */ (reader.readEnum());
      msg.setDeliveryType(value);
      break;
    case 23:
      var value = /** @type {!proto.common.OrderApprovalType} */ (reader.readEnum());
      msg.setApprovalType(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentGuidelines(value);
      break;
    case 25:
      var value = /** @type {!proto.common.OrderContentGuidelineType} */ (reader.readEnum());
      msg.setGuidelineType(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomainSpecification(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRejectedCount(value);
      break;
    case 28:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRejectionDates(values[i]);
      }
      break;
    case 29:
      var value = /** @type {!proto.concierge_order.ConcernStatus} */ (reader.readEnum());
      msg.setOptionalConcernStatus(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalConcernId(value);
      break;
    case 31:
      var value = /** @type {!proto.common.OrderPublisherType} */ (reader.readEnum());
      msg.setPublisherType(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPendingDomainCount(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTriesLeft(value);
      break;
    case 34:
      var value = /** @type {!proto.common.DomainApprovalDisplayState} */ (reader.readEnum());
      msg.setDomainApprovalState(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setApprovedDomain(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setApprovedBackupCount(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDomainRating(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDomainTraffic(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRefundAmount(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.addApprovedBackupDomains(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIndexedAt(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setBriefDocumentUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.OrderBacklinkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.OrderBacklinkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.OrderBacklinkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getLaunchedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDeadlineAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getApprovedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLiveAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRequestedTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getRequestedAnchor();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPublishedTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPublishedAnchor();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getDomainRating();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getDomainTraffic();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getIsLastRejectTry();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getApprovalType();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getContentGuidelines();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getGuidelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getDomainSpecification();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getRejectedCount();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getRejectionDatesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      28,
      f
    );
  }
  f = message.getOptionalConcernStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      29,
      f
    );
  }
  f = message.getOptionalConcernId();
  if (f !== 0) {
    writer.writeInt64(
      30,
      f
    );
  }
  f = message.getPublisherType();
  if (f !== 0.0) {
    writer.writeEnum(
      31,
      f
    );
  }
  f = message.getPendingDomainCount();
  if (f !== 0) {
    writer.writeInt32(
      32,
      f
    );
  }
  f = message.getTriesLeft();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getDomainApprovalState();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getApprovedDomain();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getApprovedBackupCount();
  if (f !== 0) {
    writer.writeInt32(
      36,
      f
    );
  }
  f = message.getHasDomainRating();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getHasDomainTraffic();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getRefundAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      39,
      f
    );
  }
  f = message.getApprovedBackupDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      40,
      f
    );
  }
  f = message.getIndexedAt();
  if (f !== 0) {
    writer.writeInt64(
      41,
      f
    );
  }
  f = message.getBriefDocumentUrl();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string number = 2;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_title = 3;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getOrderTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setOrderTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string order_number = 4;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double price = 5;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double discount = 6;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional common.OrderItemStatus status = 7;
 * @return {!proto.common.OrderItemStatus}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.OrderItemStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.common.OrderItemStatus} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional common.OrderLinkQuality quality = 8;
 * @return {!proto.common.OrderLinkQuality}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getQuality = function() {
  return /** @type {!proto.common.OrderLinkQuality} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.common.OrderLinkQuality} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 launched_at = 9;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getLaunchedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setLaunchedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 deadline_at = 10;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDeadlineAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDeadlineAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 approved_at = 11;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getApprovedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setApprovedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 live_at = 12;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getLiveAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setLiveAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 owner_id = 13;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string requested_target_url = 14;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getRequestedTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setRequestedTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string requested_anchor = 15;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getRequestedAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setRequestedAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string published_target_url = 16;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getPublishedTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setPublishedTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string published_anchor = 17;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getPublishedAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setPublishedAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int32 domain_rating = 18;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDomainRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDomainRating = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional double domain_traffic = 19;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDomainTraffic = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDomainTraffic = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional bool is_last_reject_try = 20;
 * @return {boolean}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getIsLastRejectTry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setIsLastRejectTry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional int32 total_items = 21;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional common.OrderDeliveryType delivery_type = 22;
 * @return {!proto.common.OrderDeliveryType}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDeliveryType = function() {
  return /** @type {!proto.common.OrderDeliveryType} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.common.OrderDeliveryType} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional common.OrderApprovalType approval_type = 23;
 * @return {!proto.common.OrderApprovalType}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getApprovalType = function() {
  return /** @type {!proto.common.OrderApprovalType} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.common.OrderApprovalType} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setApprovalType = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional string content_guidelines = 24;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getContentGuidelines = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setContentGuidelines = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional common.OrderContentGuidelineType guideline_type = 25;
 * @return {!proto.common.OrderContentGuidelineType}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getGuidelineType = function() {
  return /** @type {!proto.common.OrderContentGuidelineType} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.common.OrderContentGuidelineType} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setGuidelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional string domain_specification = 26;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDomainSpecification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDomainSpecification = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional int32 rejected_count = 27;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getRejectedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setRejectedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * repeated int64 rejection_dates = 28;
 * @return {!Array<number>}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getRejectionDatesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 28));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setRejectionDatesList = function(value) {
  return jspb.Message.setField(this, 28, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.addRejectionDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 28, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.clearRejectionDatesList = function() {
  return this.setRejectionDatesList([]);
};


/**
 * optional ConcernStatus optional_concern_status = 29;
 * @return {!proto.concierge_order.ConcernStatus}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getOptionalConcernStatus = function() {
  return /** @type {!proto.concierge_order.ConcernStatus} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {!proto.concierge_order.ConcernStatus} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setOptionalConcernStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 29, value);
};


/**
 * optional int64 optional_concern_id = 30;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getOptionalConcernId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setOptionalConcernId = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional common.OrderPublisherType publisher_type = 31;
 * @return {!proto.common.OrderPublisherType}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getPublisherType = function() {
  return /** @type {!proto.common.OrderPublisherType} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {!proto.common.OrderPublisherType} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setPublisherType = function(value) {
  return jspb.Message.setProto3EnumField(this, 31, value);
};


/**
 * optional int32 pending_domain_count = 32;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getPendingDomainCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setPendingDomainCount = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional int32 tries_left = 33;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getTriesLeft = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setTriesLeft = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional common.DomainApprovalDisplayState domain_approval_state = 34;
 * @return {!proto.common.DomainApprovalDisplayState}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getDomainApprovalState = function() {
  return /** @type {!proto.common.DomainApprovalDisplayState} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.common.DomainApprovalDisplayState} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setDomainApprovalState = function(value) {
  return jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional string approved_domain = 35;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getApprovedDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setApprovedDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional int32 approved_backup_count = 36;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getApprovedBackupCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setApprovedBackupCount = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional bool has_domain_rating = 37;
 * @return {boolean}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getHasDomainRating = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setHasDomainRating = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional bool has_domain_traffic = 38;
 * @return {boolean}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getHasDomainTraffic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setHasDomainTraffic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional double refund_amount = 39;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getRefundAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 39, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setRefundAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 39, value);
};


/**
 * repeated string approved_backup_domains = 40;
 * @return {!Array<string>}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getApprovedBackupDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 40));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setApprovedBackupDomainsList = function(value) {
  return jspb.Message.setField(this, 40, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.addApprovedBackupDomains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 40, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.clearApprovedBackupDomainsList = function() {
  return this.setApprovedBackupDomainsList([]);
};


/**
 * optional int64 indexed_at = 41;
 * @return {number}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getIndexedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setIndexedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional string brief_document_url = 42;
 * @return {string}
 */
proto.concierge_order.OrderBacklinkResponse.prototype.getBriefDocumentUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.OrderBacklinkResponse} returns this
 */
proto.concierge_order.OrderBacklinkResponse.prototype.setBriefDocumentUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConcernAttachedFile.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConcernAttachedFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConcernAttachedFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernAttachedFile.toObject = function(includeInstance, msg) {
  var f, obj = {
uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
size: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConcernAttachedFile}
 */
proto.concierge_order.ConcernAttachedFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConcernAttachedFile;
  return proto.concierge_order.ConcernAttachedFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConcernAttachedFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConcernAttachedFile}
 */
proto.concierge_order.ConcernAttachedFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConcernAttachedFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConcernAttachedFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConcernAttachedFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernAttachedFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.concierge_order.ConcernAttachedFile.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConcernAttachedFile} returns this
 */
proto.concierge_order.ConcernAttachedFile.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.concierge_order.ConcernAttachedFile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConcernAttachedFile} returns this
 */
proto.concierge_order.ConcernAttachedFile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.concierge_order.ConcernAttachedFile.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConcernAttachedFile} returns this
 */
proto.concierge_order.ConcernAttachedFile.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size = 4;
 * @return {number}
 */
proto.concierge_order.ConcernAttachedFile.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernAttachedFile} returns this
 */
proto.concierge_order.ConcernAttachedFile.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConcernMessageResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConcernMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConcernMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConcernMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
authorType: jspb.Message.getFieldWithDefault(msg, 2, 0),
optionalAuthorId: jspb.Message.getFieldWithDefault(msg, 3, 0),
authorName: jspb.Message.getFieldWithDefault(msg, 4, ""),
body: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.concierge_order.ConcernAttachedFile.toObject, includeInstance),
optionalReplyToMessageId: jspb.Message.getFieldWithDefault(msg, 8, 0),
internalNote: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConcernMessageResponse}
 */
proto.concierge_order.ConcernMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConcernMessageResponse;
  return proto.concierge_order.ConcernMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConcernMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConcernMessageResponse}
 */
proto.concierge_order.ConcernMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.concierge_order.ConcernAuthorType} */ (reader.readEnum());
      msg.setAuthorType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalAuthorId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new proto.concierge_order.ConcernAttachedFile;
      reader.readMessage(value,proto.concierge_order.ConcernAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalReplyToMessageId(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternalNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConcernMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConcernMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConcernMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAuthorType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOptionalAuthorId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAuthorName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.concierge_order.ConcernAttachedFile.serializeBinaryToWriter
    );
  }
  f = message.getOptionalReplyToMessageId();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getInternalNote();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ConcernAuthorType author_type = 2;
 * @return {!proto.concierge_order.ConcernAuthorType}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getAuthorType = function() {
  return /** @type {!proto.concierge_order.ConcernAuthorType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.concierge_order.ConcernAuthorType} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setAuthorType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 optional_author_id = 3;
 * @return {number}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getOptionalAuthorId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setOptionalAuthorId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string author_name = 4;
 * @return {string}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getAuthorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setAuthorName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string body = 5;
 * @return {string}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated ConcernAttachedFile attached_files = 7;
 * @return {!Array<!proto.concierge_order.ConcernAttachedFile>}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.concierge_order.ConcernAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConcernAttachedFile, 7));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernAttachedFile>} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
*/
proto.concierge_order.ConcernMessageResponse.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.concierge_order.ConcernAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConcernAttachedFile}
 */
proto.concierge_order.ConcernMessageResponse.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.concierge_order.ConcernAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};


/**
 * optional int64 optional_reply_to_message_id = 8;
 * @return {number}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getOptionalReplyToMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setOptionalReplyToMessageId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool internal_note = 9;
 * @return {boolean}
 */
proto.concierge_order.ConcernMessageResponse.prototype.getInternalNote = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_order.ConcernMessageResponse} returns this
 */
proto.concierge_order.ConcernMessageResponse.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.ConcernResponse.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.ConcernResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.ConcernResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.ConcernResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
orderItemId: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
areasList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.concierge_order.ConcernMessageResponse.toObject, includeInstance),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.ConcernResponse}
 */
proto.concierge_order.ConcernResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.ConcernResponse;
  return proto.concierge_order.ConcernResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.ConcernResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.ConcernResponse}
 */
proto.concierge_order.ConcernResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {!proto.concierge_order.ConcernStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.concierge_order.ConcernArea>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAreas(values[i]);
      }
      break;
    case 6:
      var value = new proto.concierge_order.ConcernMessageResponse;
      reader.readMessage(value,proto.concierge_order.ConcernMessageResponse.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.ConcernResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.ConcernResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.ConcernResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.ConcernResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAreasList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.concierge_order.ConcernMessageResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_order.ConcernResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 order_item_id = 2;
 * @return {number}
 */
proto.concierge_order.ConcernResponse.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.concierge_order.ConcernResponse.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ConcernStatus status = 4;
 * @return {!proto.concierge_order.ConcernStatus}
 */
proto.concierge_order.ConcernResponse.prototype.getStatus = function() {
  return /** @type {!proto.concierge_order.ConcernStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.concierge_order.ConcernStatus} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated ConcernArea areas = 5;
 * @return {!Array<!proto.concierge_order.ConcernArea>}
 */
proto.concierge_order.ConcernResponse.prototype.getAreasList = function() {
  return /** @type {!Array<!proto.concierge_order.ConcernArea>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernArea>} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setAreasList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.concierge_order.ConcernArea} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.addAreas = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.clearAreasList = function() {
  return this.setAreasList([]);
};


/**
 * repeated ConcernMessageResponse messages = 6;
 * @return {!Array<!proto.concierge_order.ConcernMessageResponse>}
 */
proto.concierge_order.ConcernResponse.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.concierge_order.ConcernMessageResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConcernMessageResponse, 6));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernMessageResponse>} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
*/
proto.concierge_order.ConcernResponse.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.concierge_order.ConcernMessageResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConcernMessageResponse}
 */
proto.concierge_order.ConcernResponse.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.concierge_order.ConcernMessageResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.concierge_order.ConcernResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.concierge_order.ConcernResponse.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.ConcernResponse} returns this
 */
proto.concierge_order.ConcernResponse.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.RaiseConcernRequest.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.RaiseConcernRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.RaiseConcernRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.RaiseConcernRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RaiseConcernRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderItemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
areasList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
message: jspb.Message.getFieldWithDefault(msg, 4, ""),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.concierge_order.ConcernAttachedFile.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.RaiseConcernRequest}
 */
proto.concierge_order.RaiseConcernRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.RaiseConcernRequest;
  return proto.concierge_order.RaiseConcernRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.RaiseConcernRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.RaiseConcernRequest}
 */
proto.concierge_order.RaiseConcernRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.concierge_order.ConcernArea>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAreas(values[i]);
      }
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 5:
      var value = new proto.concierge_order.ConcernAttachedFile;
      reader.readMessage(value,proto.concierge_order.ConcernAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.RaiseConcernRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.RaiseConcernRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.RaiseConcernRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.RaiseConcernRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAreasList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.concierge_order.ConcernAttachedFile.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 order_item_id = 1;
 * @return {number}
 */
proto.concierge_order.RaiseConcernRequest.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.RaiseConcernRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ConcernArea areas = 3;
 * @return {!Array<!proto.concierge_order.ConcernArea>}
 */
proto.concierge_order.RaiseConcernRequest.prototype.getAreasList = function() {
  return /** @type {!Array<!proto.concierge_order.ConcernArea>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernArea>} value
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.setAreasList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.concierge_order.ConcernArea} value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.addAreas = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.clearAreasList = function() {
  return this.setAreasList([]);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.concierge_order.RaiseConcernRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated ConcernAttachedFile attached_files = 5;
 * @return {!Array<!proto.concierge_order.ConcernAttachedFile>}
 */
proto.concierge_order.RaiseConcernRequest.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.concierge_order.ConcernAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConcernAttachedFile, 5));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernAttachedFile>} value
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
*/
proto.concierge_order.RaiseConcernRequest.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.concierge_order.ConcernAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConcernAttachedFile}
 */
proto.concierge_order.RaiseConcernRequest.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.concierge_order.ConcernAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.RaiseConcernRequest} returns this
 */
proto.concierge_order.RaiseConcernRequest.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.GetConcernRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.GetConcernRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.GetConcernRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.GetConcernRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderItemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.GetConcernRequest}
 */
proto.concierge_order.GetConcernRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.GetConcernRequest;
  return proto.concierge_order.GetConcernRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.GetConcernRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.GetConcernRequest}
 */
proto.concierge_order.GetConcernRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderItemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.GetConcernRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.GetConcernRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.GetConcernRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.GetConcernRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderItemId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 order_item_id = 1;
 * @return {number}
 */
proto.concierge_order.GetConcernRequest.prototype.getOrderItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.GetConcernRequest} returns this
 */
proto.concierge_order.GetConcernRequest.prototype.setOrderItemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.GetConcernRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.GetConcernRequest} returns this
 */
proto.concierge_order.GetConcernRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_order.AddConcernMessageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_order.AddConcernMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_order.AddConcernMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.AddConcernMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
concernId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
body: jspb.Message.getFieldWithDefault(msg, 3, ""),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.concierge_order.ConcernAttachedFile.toObject, includeInstance),
optionalReplyToMessageId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_order.AddConcernMessageRequest}
 */
proto.concierge_order.AddConcernMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_order.AddConcernMessageRequest;
  return proto.concierge_order.AddConcernMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_order.AddConcernMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_order.AddConcernMessageRequest}
 */
proto.concierge_order.AddConcernMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConcernId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = new proto.concierge_order.ConcernAttachedFile;
      reader.readMessage(value,proto.concierge_order.ConcernAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalReplyToMessageId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_order.AddConcernMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_order.AddConcernMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_order.AddConcernMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConcernId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.concierge_order.ConcernAttachedFile.serializeBinaryToWriter
    );
  }
  f = message.getOptionalReplyToMessageId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 concern_id = 1;
 * @return {number}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.getConcernId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
 */
proto.concierge_order.AddConcernMessageRequest.prototype.setConcernId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
 */
proto.concierge_order.AddConcernMessageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
 */
proto.concierge_order.AddConcernMessageRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ConcernAttachedFile attached_files = 4;
 * @return {!Array<!proto.concierge_order.ConcernAttachedFile>}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.concierge_order.ConcernAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_order.ConcernAttachedFile, 4));
};


/**
 * @param {!Array<!proto.concierge_order.ConcernAttachedFile>} value
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
*/
proto.concierge_order.AddConcernMessageRequest.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.concierge_order.ConcernAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_order.ConcernAttachedFile}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.concierge_order.ConcernAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
 */
proto.concierge_order.AddConcernMessageRequest.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};


/**
 * optional int64 optional_reply_to_message_id = 5;
 * @return {number}
 */
proto.concierge_order.AddConcernMessageRequest.prototype.getOptionalReplyToMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_order.AddConcernMessageRequest} returns this
 */
proto.concierge_order.AddConcernMessageRequest.prototype.setOptionalReplyToMessageId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.concierge_order.ExcludedDomainFilterField = {
  STRING_DOMAIN: 0,
  DROPDOWN_WORKSPACE_ID: 1,
  STRING_SCOPE: 2
};

/**
 * @enum {number}
 */
proto.concierge_order.CampaignFilterField = {
  STRING_CAMPAIGN_NAME: 0,
  STRING_CAMPAIGN_URL: 1,
  DROPDOWN_CAMPAIGN_STATUS: 2,
  DROPDOWN_CAMPAIGN_REGION: 3,
  DROPDOWN_CAMPAIGN_AUTONOMY: 4,
  DATE_CAMPAIGN_CREATED_AT: 5,
  DATE_CLIENT_CAMPAIGN_ARCHIVED_AT: 6,
  DROPDOWN_CLIENT_CAMPAIGN_FOLDER_ID: 7
};

/**
 * @enum {number}
 */
proto.concierge_order.OrderFilterField = {
  STRING_CLIENT_ORDER_NUMBER: 0,
  STRING_CLIENT_ORDER_TITLE: 1,
  DROPDOWN_CLIENT_ORDER_STATUS: 2,
  DROPDOWN_CLIENT_ORDER_OWNER: 3,
  DATE_CLIENT_ORDER_ORDERED_AT: 4,
  DATE_CLIENT_ORDER_ARCHIVED_AT: 5,
  DATE_CLIENT_ORDER_CREATED_AT: 6,
  DROPDOWN_CLIENT_ORDER_FOLDER_ID: 7,
  DATE_CLIENT_ORDER_DEADLINE_AT: 8,
  NUMBER_CLIENT_ORDER_CAMPAIGN_ID: 9
};

/**
 * @enum {number}
 */
proto.concierge_order.DomainApprovalOutcome = {
  DOMAIN_APPROVAL_OUTCOME_UNSPECIFIED: 0,
  DOMAIN_APPROVAL_OUTCOME_APPROVED: 1,
  DOMAIN_APPROVAL_OUTCOME_SOURCING_NEW_DOMAINS: 2,
  DOMAIN_APPROVAL_OUTCOME_ALL_REJECTED_CREDITED: 3
};

/**
 * @enum {number}
 */
proto.concierge_order.OrderBacklinkFilterField = {
  STRING_ORDER_BACKLINK_NUMBER: 0,
  DROPDOWN_ORDER_BACKLINK_STATUS: 1,
  DROPDOWN_ORDER_BACKLINK_OWNER: 2,
  DATE_ORDER_BACKLINK_LAUNCHED_AT: 3,
  DATE_ORDER_BACKLINK_DEADLINE_AT: 4,
  DROPDOWN_ORDER_BACKLINK_QUALITY: 5,
  STRING_ORDER_BACKLINK_REQUESTED_URL: 6,
  STRING_ORDER_BACKLINK_REQUESTED_ANCHOR: 7,
  DROPDOWN_ORDER_BACKLINK_CONCERN_STATUS: 8,
  DATE_ORDER_BACKLINK_LIVE_AT: 9
};

/**
 * @enum {number}
 */
proto.concierge_order.OrderBacklinkSortProto = {
  ORDER_BACKLINK_SORT_DEFAULT: 0,
  ORDER_BACKLINK_SORT_LIVE_AT: 1
};

/**
 * @enum {number}
 */
proto.concierge_order.ConcernStatus = {
  CONCERN_STATUS_UNSPECIFIED: 0,
  CONCERN_STATUS_RAISED: 1,
  CONCERN_STATUS_IN_REVIEW: 2,
  CONCERN_STATUS_RESOLVED: 3
};

/**
 * @enum {number}
 */
proto.concierge_order.ConcernArea = {
  CONCERN_AREA_UNSPECIFIED: 0,
  CONCERN_AREA_TARGET_URL: 1,
  CONCERN_AREA_ANCHOR: 2,
  CONCERN_AREA_CONTENT: 3,
  CONCERN_AREA_PUBLISHER_DOMAIN: 4,
  CONCERN_AREA_OTHER: 5
};

/**
 * @enum {number}
 */
proto.concierge_order.ConcernAuthorType = {
  CONCERN_AUTHOR_TYPE_UNSPECIFIED: 0,
  CONCERN_AUTHOR_TYPE_CLIENT: 1,
  CONCERN_AUTHOR_TYPE_RESPONA_TEAM: 2
};

goog.object.extend(exports, proto.concierge_order);
